import zhHans from 'vuetify/es5/locale/zh-Hans';
export default {
    ...zhHans,
    setting: {
		language: "Chineză Simplificată",
		dialogDetermine: "Confirmare",
		dreivatives: "Contracte futures",
		markets: "Piață",
		assets: "Active",
		liquidity: "Minerit de lichiditate",
		helpCentre: "Centru de ajutor",
		announcementCenter: "Centru de anunțuri",
		about: "Despre",
		bulletinCentre: "Centru de anunțuri",
		serviceAgreement: "Acord de servicii",
		support: "Asistență",
		onlineSupportCustomerService: "Serviciu clienți online",
		suggestionsAndFeedback: "Sugestii și feedback",
		service: "Serviciu",
		download: "Descărcare",
		coinApplication: "Cerere listare monedă",
		privacyStatement: "Declarație de confidențialitate",
		trade: "Tranzacționare contracte",
		standardConteact: "Perpetuu",
		signOut: "Deconectare",
		assetWallets: "Portofel de active",
		financeRecords: "Înregistrări financiare",
		identification: "Verificare identitate",
		personalCenter: "Centru personal",
		chooseLanguage: "Alegeți limba",
		tips: "Sfaturi",
		dark: "Mod întunecat",
		light: "Mod luminos",
		languageTitle: "Limbă",
		convertCurrency: "Conversie valută",
		cancel: "Anulare",
		aboutUs: "Despre noi",
		standard: "Contract perpetuu standard",
		share: "Distribuie",
		introduce: "Prezentarea platformei",
		set: "Setări",
		changePassword: "Schimbare parolă",
		denomination: "Monedă de referință",
		color: "Setări culoare",
		code: "Versiune",
		color1: "Roșu ↑ Verde ↓",
		color2: "Verde ↑ Roșu ↓",
		setLangue: "Setează limba",
		vip: "Beneficii VIP",
		vip2: "Nivel VIP curent",
		safeMenu: "Centru de securitate",
		conventional: "General",
		other: "Altele",
		quickTips: "Puteți adăuga maximum 3 butoane de funcții rapide",
		quickTransaction: "Tranzacție rapidă",
		safeConvenient: "Sigur și convenabil",
		timeSharing: "Grafic pe intervale",
		currentLevel: "Nivel actual",
		levelBenefits: "Beneficii nivel %{level}",
		teamLevel: "Nivel echipă",
		levelLower: "Nivel %{level} inferior",
		rules: "Reguli",
		bindWithdrawalAddress: "Leagă adresa de retragere",
		tipsBindWithdrawalAddress: "Nu ați legat încă o adresă de retragere, vă rugăm să o legați mai întâi",
		walletAddressFormatIncorrect: "Formatul adresei portofelului este incorect",
		tradeRules1: "Preziceți creșterea sau scăderea într-o anumită perioadă viitoare. Prețul la momentul plasării comenzii este prețul inițial, iar prețul la ultima secundă a perioadei de predicție este prețul de decontare. Dacă prețul de decontare este mai mare decât prețul inițial, este considerată o creștere; dacă este mai mic, este o scădere.",
		tradeRules2: "1. Ce este un contract",
		tradeRules3: "Platforma oferă contracte perpetue denominate în USDT. Utilizatorii pot obține profit din creșterea/scăderea prețului activelor digitale prin deschiderea de poziții long (cumpărare) sau short (vânzare). Contractele perpetue nu au dată de expirare și pot fi deținute pe termen nelimitat.",
		tradeRules4: "2. Ce este marja",
		tradeRules5: "Pe piața de contracte virtuale, utilizatorii trebuie doar să plătească un procent mic din valoarea contractului ca garanție pentru a participa la tranzacționare. Această sumă este marja contractului. \nPlatforma utilizează un model de marjă izolat pe conturi separate. Fiecare monedă are propriul cont de contract. Activele și pozițiile fiecărui cont sunt independente și nu se influențează reciproc.",
		tradeRules6: "3. Cum se calculează marja",
		tradeRules7: "Marja poziției = Valoarea nominală * Numărul de contracte / Levier\nMarja blocată = Suma marjelor pentru toate comenzile de deschidere plasate\nMarja disponibilă = Sold cont - Marja poziției - Marja blocată",
		tradeRules8: "4. Cum se calculează rata marjei",
		tradeRules9: "Rata marjei este un indicator al riscului activelor utilizatorului.\nRata marjei = (PNL nerealizat + Marja poziției + Marja disponibilă + Marja blocată - Taxe închidere) / Marja poziției\nCu cât rata marjei este mai mică, cu atât riscul este mai mare. Dacă scade sub 0%, se va activa lichidarea forțată.",
		tradeRules10: "5. Ce este prețul estimat de lichidare",
		tradeRules11: "Este prețul teoretic la care se va declanșa lichidarea forțată, calculat de sistem. Este doar orientativ și poate avea abateri față de valoarea reală.",
		tradeRules12: "6. Ce sunt valoarea totală a contului și PNL-ul nerealizat",
		tradeRules13: "Valoare totală a contului = Sold cont + PNL nerealizat\nPNL-ul nerealizat este profitul sau pierderea poziției curente în acel contract. Se schimbă în funcție de prețul de piață.\nPNL long = (1/Preț mediu - 1/Preț curent) * Nr. contracte * Valoare nominală * Preț curent\nPNL short = (1/Preț curent - 1/Preț mediu) * Nr. contracte * Valoare nominală * Preț curent",
		text1: "Securitatea contului",
		text2: "Mod zi/noapte",
		text3: "Golește memoria cache",
		text4: "Sigur doriți să vă deconectați?",
		text5: "Sigur doriți să goliți memoria cache?",
		text6: "Multilingv",
		text7: "Pentru siguranța dvs., se recomandă activarea a cel puțin unei metode de autentificare cu doi factori"
    },
    login: {
		login: "Autentificare",
		register: "Înregistrare",
		title1: "Tranzacționați oriunde, vizualizați prețuri în timp real",
		title2: "Tranzacționați oriunde, vizualizați prețuri în timp real",
		title3: "Cea mai de încredere platformă de tranzacționare a criptomonedelor",
		formTitle1: "Autentificare cont",
		formTitle2: "Bine ați revenit! Conectați-vă cu emailul sau numărul de telefon",
		btn1: "Telefon",
		btn2: "Email",
		btn3: "Autentificare",
		btn4: "Înregistrare",
		btn5: "Ați uitat parola?",
		field1: "Număr de telefon",
		field2: "Parolă",
		field3: "Email",
		placeholder1: "Țară",
		placeholder2: "Introduceți numărul de telefon",
		placeholder3: "Introduceți parola",
		placeholder4: "Introduceți adresa de email",
		content12: "Vă rugăm să introduceți numărul de telefon",
		content13: "Vă rugăm să introduceți parola",
		content14: "Vă rugăm să introduceți emailul",
		content16: "Servicii financiare pentru active digitale",
		loginSuccess: "Autentificare reușită",
		chooseArea: "Vă rugăm să selectați un prefix de țară",
		placeholder5: "Selectați codul de țară",
		placeholder6: "Ține-mă minte",
		placeholder7: "Descarcă aplicația",
		placeholder8: "Contactați serviciul clienți",
		placeholder9: "Selectați țara sau regiunea",
		placeholder10: "Prefix",
		placeholder11: "Autentificare portofel",
		placeholder12: "Operațiune eșuată, vă rugăm să comutați la",
		placeholder13: "Portofel"
    },
    aboutUs: {
		aboutCoinbeadCenterTitle: "Despre",
		aboutCoinbeadCenterDetails: "Deține o platformă de tranzacționare a activelor blockchain de top la nivel mondial și operează întregul ecosistem.",
		footDetails1: "Volum zilnic de tranzacționare",
		footDetails2: "Tranzacții pe secundă",
		footDetails3: "Centru de ajutor",
		coinbeadCenterTitle: "",
		coinbeadCenterDetails: "Este o platformă internațională renumită pentru active digitale, oferind utilizatorilor globali servicii pentru Bitcoin (BTC), Litecoin (LTC), Ethereum (ETH) și alte monede și produse derivate.",
		coinbeadCenterDetailsm: "Folosește tehnologii avansate precum GSLB, servere de rețea, tranzacționare web, rețele redundante, motor de tranzacționare în memorie de mare viteză, portofel rece, portofel cald inteligent offline etc. Prin intermediul versiunilor web, mobile și PC, oferim clienților noștri servicii de tranzacționare digitale sigure, stabile și fiabile. De asemenea, îmbunătățim și actualizăm produsele și serviciile în funcție de sugestiile și nevoile utilizatorilor pentru a oferi fiecărui client servicii mai bune și pentru a inova continuu experiența utilizatorului.",
		infrastructureCenterTitle: "Infrastructură",
		infrastructureCenterDetails: "Misiunea noastră este să oferim servicii de infrastructură pentru întregul ecosistem blockchain.",
		freeCenterTitle: "Libertate",
		freeCenterDetails: "Viziunea noastră este de a permite circulația liberă a banilor la nivel global. Credem că răspândirea acestei libertăți va face lumea un loc mai bun.",
		futureCenterTitle: "Deschiderea viitorului tehnologic",
		futureCenterDetails: "Open up the future of technology",
    },
    applicationForListing: {
		title: "Cerere listare monedă",
		projectName: "Numele proiectului",
		tokenName: "Numele tokenului",
		projectDescription: "Descrierea proiectului",
		contractAddress: "Adresă contract",
		officialWebsite: "Site oficial",
		ContactAndEmail: "Email persoană de contact",
		ContactAndName: "Nume persoană de contact",
		file: "Încărcare atașament",
		pleaseEnter: "Vă rugăm să introduceți",
		enterFile: "Vă rugăm să încărcați fișierul",
		upload1: "În prezent este permisă selectarea unui singur fișier,",
		upload2: "Ați selectat",
		upload3: " fișier(e),",
		upload4: "În total ați selectat",
		upload5: " fișier(e)",
    },
    public: {
		submit: "Trimite",
		copySuccessfully: "Copiat cu succes",
		copyFailed: "Copiere eșuată",
		noDate: "Nu există date",
		submitSuccessfully: "Trimitere reușită",
		goBack: "Înapoi la pagina anterioară",
		cancel: "Anulare",
		home: "Pagina principală",
		loading: "Se încarcă...",
		confirm: "Confirmare",
		loadingFailed: "Eroare de rețea",
		nomore: "Nu mai sunt date",
		tryAgain: "Reîncărcați pagina / ieșiți din aplicație și reîncercați!",
		hot: "Zonă populară",
    },
    inviteFriends: {
		inviteFriends: "Invită prieteni",
		freedomOfWealth: "Să eliberăm averea împreună",
		myInvitationCode: "Codul meu de invitație",
		clickCopy: "Fă clic pentru a copia",
		myInvitationLink: "Linkul meu de invitație",
		clicktoSaveTheQRCode: "Clic pentru a salva codul QR",
		saveQRCode: "Cod QR invitație",
		numberOfSubordinates: "Număr de subordonați",
		rebateIncome: "Venituri din comisioane",
		people: "persoane",
		myPromotionRevenue: "Venitul meu din promovare",
		numberOfDirectSubordinates: "Număr de subordonați direcți",
		totalNumberOfSubordinates: "Număr total de subordonați",
		directSubordinateReturnsCommission: "Comision returnat de subordonați direcți",
		theTotalCommission: "Comision total",
		checkHistory: "Vezi istoricul comisioanelor",
		history: "Istoricul comisioanelor",
		theLowerAccount: "Cont subordonat",
		type: "Tip:",
		serviceCharge: "Taxă de serviciu:",
		percentageofCommissionReturned: "Procent comision returnat:",
		commissionrebateAmount: "Suma comisionului returnat:",
		time: "Timp:",
		typeName1: "Comision din reîncărcare",
		typeName2: "Comision pe 3 niveluri din comision MT",
		typeName3: "Profit MT pe 3 niveluri",
		typeName4: "Recompensă de recomandare",
		typeName30: "Comision din reîncărcare",
		typeName31: "Comision din profitul tranzacțiilor pe perioadă",
		typeName32: "Comision din profitul mineritului de lichiditate",
		typeName45: "Comision din taxa de tranzacție",
		typeName46: "Comision returnat pentru propria taxă",
		typeName50: "Comision din taxa de tranzacție pentru contracte la termen",
		typeName51: "Comision din taxa de tranzacție pentru contracte perpetue",
		typeName52: "Comision suplimentar pentru contracte la termen",
		typeName53: "Comision suplimentar pentru contracte perpetue",
		typeName54: "Ramburs suplimentar pentru contracte perpetue",
		shareRules1: "Instrucțiuni de invitație",
		shareRules2: "Intră în centrul de invitații, copiază linkul sau codul de invitație și distribuie-l prietenilor tăi. Prietenii care se înregistrează folosind codul tău vor deveni subordonații tăi.",
		shareRules3: "Câștigă comision",
		shareRules4: "Când subordonații tăi tranzacționează, poți primi un comision corespunzător. Se acceptă până la trei niveluri de subordonați. De exemplu, tu inviți pe A, A îl invită pe B, B îl invită pe C – când A, B sau C tranzacționează pe platformă, tu primești comision.",
		shareRules5: "Nivelul echipei",
		shareRules6: "Cu cât ai mai mulți subordonați de nivel 1, cu atât nivelul echipei tale este mai mare și beneficiezi de un comision mai mare. Nivelurile echipei sunt LV1–LV6. Regulile de promovare sunt prezentate în tabelul de mai jos. 'N' reprezintă numărul subordonaților care au efectuat reîncărcări și au finalizat verificarea identității.",
		shareRules7: "Când subordonații tăi participă la pariuri pe contracte la termen, primești comision proporțional cu suma pariului.",
		upgradeConditions: "Cerințe",
		recommendedNumberOfPeople: "Număr de persoane recomandate"
    },
    suggestionsAndFeedback: {
		suggestionsAndFeedback: "Sugestii și feedback",
		text: "Dacă întâmpini bug-uri sau ai sugestii privind produsul, te rugăm să ne contactezi",
		email: "Adresă de email",
		enterEmail: "Te rugăm să introduci adresa de email",
		enterCorrectEmail: "Te rugăm să introduci o adresă de email corectă",
		title: "Titlu",
		enterTitle: "Te rugăm să introduci titlul problemei",
		describeTheProblem: "Descrie problema",
		enterDescribeTheProblem: "Te rugăm să descrii problema ta",
		submit: "Trimite",
    },
    help: {
		enterSearch: "Căutare",
		title: "Centru de Ajutor",
		search: "Te rugăm să introduci întrebarea ta",
		text1: "Înțelegem nevoile tale și îți oferim servicii tot mai convenabile"
    },
    announcement: {
		enterSearch: "Căutare",
		title: "Centrul de Anunțuri",
		search: "Te rugăm să introduci întrebarea ta"
    },
    privacy: {
		title: "Declarație de confidențialitate",
		content1: "1. Ce informații personale colectăm de la utilizatori?",
		content2: "Colectăm informațiile personale pentru a oferi produse și servicii și pentru a le îmbunătăți continuu.",
		content3: "Iată tipurile de informații personale pe care le colectăm:",
		content4: "Informațiile pe care ni le furnizați: primim și stocăm orice informație pe care ne-o furnizați legată de această platformă. Puteți alege să nu furnizați anumite informații, dar acest lucru poate limita accesul la unele „servicii ale platformei”. Exemple de informații pe care ni le furnizați includ:",
		content5: "Nume",
		content6: "Adresă",
		content7: "Naționalitate",
		content8: "Fotografie a documentului de identitate",
		content9: "Număr de telefon mobil / adresă de email",
		content10: "Alte informații care ne ajută să vă identificăm",
		content11: "Informații colectate automat: colectăm și stocăm automat anumite tipuri de informații despre utilizarea serviciilor platformei, la fel ca multe site-uri web folosim cookie-uri și alte identificatoare unice. Când browser-ul sau dispozitivul dvs. accesează platforma, obținem anumite tipuri de informații. Exemple de informații colectate și analizate includ:",
		content12: "Adresa IP a calculatorului personal conectat la internet;",
		content13: "Informații de autentificare ale dispozitivului personal sau calculatorului, adresa de email, parola și locația;",
		content14: "Setări de versiune și fus orar;",
		content15: "Istoricul tranzacțiilor.",
		content16: "Informații din alte surse: putem colecta informații despre dvs. din alte surse (de exemplu, istoricul de credit de la agențiile de raportare a creditului). Vom folosi aceste informații pentru a preveni și detecta fraude.",
		content17: "2. Pot copiii să folosească platforma?",
		content18: "Această platformă nu permite persoanelor sub 18 ani să utilizeze „serviciile”.",
		content19: "3. La ce folosesc cookie-urile și alte identificatoare?",
		content20: "Folosim cookie-uri și instrumente similare pentru a optimiza experiența utilizatorului, a furniza serviciile noastre și a înțelege cum folosesc clienții serviciile pentru a le îmbunătăți. Cookie-urile ne ajută să identificăm browserul sau dispozitivul dvs. și să vă oferim serviciile.",
		content21: "Folosim cookie-uri operaționale și instrumente similare (denumite colectiv „Cookie-uri”) pentru a furniza servicii, de exemplu:",
		content22: "Pentru a vă identifica când vă autentificați și folosiți serviciile noastre.",
		content23: "Pentru a oferi funcții și servicii personalizate.",
		content24: "Pentru a preveni activitățile frauduloase.",
		content25: "Pentru a îmbunătăți securitatea.",
		content26: "Pentru a urmări preferințele dvs. (cum ar fi moneda și limba).",
		content27: "De asemenea, folosim cookie-uri pentru a înțelege cum utilizează utilizatorii serviciile noastre și pentru a face îmbunătățiri țintite.",
		content28: "4. Îmi vor fi împărtășite informațiile mele personale?",
		content29: "Informațiile utilizatorilor sunt o componentă importantă a afacerii noastre și nu vom vinde informațiile personale ale utilizatorilor către terți. Platforma împărtășește informațiile personale ale utilizatorilor doar în următoarele situații cu subsidiarele sau entitățile afiliate, care trebuie să respecte această declarație de confidențialitate sau să adopte practici de protecție cel puțin la fel de stricte ca cele prevăzute aici.",
		content30: "Furnizori terți de servicii: angajăm alte companii și persoane pentru a îndeplini funcții în numele nostru. Exemplele acestor funcții includ: analiză de date, asistență în marketing, procesarea plăților, transmiterea conținutului și evaluarea și gestionarea riscului de credit. Acești furnizori terți pot avea acces la informațiile personale necesare pentru îndeplinirea acestor funcții, dar nu le pot folosi în alte scopuri. În plus, aceștia trebuie să respecte această declarație de confidențialitate și legislația aplicabilă privind protecția datelor.",
		content31: "Transferuri de afaceri: pe măsură ce afacerea noastră evoluează, este posibil să vindem sau să cumpărăm alte afaceri sau servicii. În astfel de tranzacții, informațiile utilizatorilor fac de obicei parte din activele afacerii transferate, dar rămân supuse angajamentelor din orice declarație de confidențialitate existentă (cu excepția cazului în care utilizatorul a consimțit altfel). De asemenea, dacă compania noastră sau cea mai mare parte a activelor sale este achiziționată, informațiile utilizatorilor vor fi transferate. Protecția companiei și a altora: când considerăm că dezvăluirea contului și a altor informații personale este o acțiune adecvată pentru a respecta legea sau obligațiile noastre de reglementare, a pune în aplicare termenii și condițiile noastre de utilizare sau alte acorduri, sau pentru a proteja drepturile, proprietatea sau siguranța utilizatorilor sau a altor persoane, vom face aceste dezvăluiri. Aceasta include schimbul de informații cu alte companii și organizații pentru a preveni fraude și a reduce riscul de credit.",
		content32: "5. Transferul internațional al datelor personale",
		content33: "Compania noastră poate transfera datele dvs. în afara Spațiului Economic European („SEE”). Vom lua măsuri adecvate pentru a asigura că acest transfer respectă regulile aplicabile privind protecția datelor, cu excepția cazului în care Comisia Europeană a confirmat că țara sau regiunea care primește datele asigură un nivel adecvat de protecție.",
		content34: "6. Sunt în siguranță informațiile mele personale?",
		content35: "La proiectarea sistemelor, avem în vedere în mod prioritar securitatea și confidențialitatea dvs. Folosim protocoale criptografice și software pentru a proteja informațiile personale pe durata transmiterii.",
		content36: "În colectarea, stocarea și divulgarea informațiilor personale, adoptăm întotdeauna măsuri de protecție fizică, electronică și procedurală. Procedurile noastre de securitate pot necesita verificarea identității dvs. înainte de a divulga informațiile personale.",
		content37: "Cel mai important pentru dvs. este să preveniți accesul neautorizat la parola contului personal. Recomandăm setarea unei parole unice diferite de cele folosite pentru alte conturi online. De asemenea, după utilizarea unui calculator partajat, asigurați-vă că vă delogați.",
		content38: "7. Cum ar trebui să-mi protejez informațiile personale?",
		content39: "Dacă aveți întrebări sau obiecții cu privire la modul în care colectăm și procesăm informațiile personale, vă rugăm să contactați serviciul clienți.",
		content40: "După ce ați consimțit ca noi să procesăm informațiile dvs. personale în anumite scopuri, puteți retrage această consimțământ în orice moment, iar noi vom înceta procesarea datelor în aceste scopuri.",
		content41: "De asemenea, în conformitate cu legislația aplicabilă, aveți dreptul să solicitați accesul, corectarea, ștergerea și portabilitatea datelor personale. De asemenea, puteți obiecta la procesarea datelor personale sau puteți solicita restricționarea acesteia în anumite situații.",
		content42: "8. GDPR-ul UE și Legea privind protecția datelor din Regatul Unit – temeiuri legale",
		content43: "GDPR-ul UE și Legea privind protecția datelor din Regatul Unit ne cer să avem o bază legală pentru utilizarea informațiilor personale. Această bază depinde de scopul specific al utilizării datelor personale. Aceste baze includ:",
		content44: "Executarea unui contract – pentru a vă oferi produse sau servicii sau pentru a comunica cu dvs., inclusiv utilizarea informațiilor personale pentru a primi și procesa comenzile și pentru a efectua plăți.",
		content45: "Interesele noastre comerciale legitime și cele ale utilizatorilor – pentru a detecta și preveni frauda și abuzul și pentru a asigura protecția utilizatorilor noștri, a noastră și a altora.",
		content46: "Consimțământul dvs. – avem nevoie de consimțământul dvs. pentru a procesa informațiile personale în scopuri specifice. După ce ați consimțit, puteți retrage acest consimțământ oricând, iar noi vom înceta procesarea datelor în aceste scopuri.",
		content47: "Respectarea obligațiilor legale – folosim informațiile dvs. personale în conformitate cu cerințele legale. De exemplu, colectăm informații despre contul bancar pentru verificarea identității.",
		content48: "Cele de mai sus și alte temeiuri legale depind de scopul specific al utilizării informațiilor personale.",
		content49: "9. Condiții de utilizare, notificări și modificări",
		content50: "Utilizarea dvs. și orice dispută legată de confidențialitate sunt guvernate de această declarație și de termenii noștri de utilizare. Dacă aveți întrebări privind confidențialitatea pe platformă, vă rugăm să ne contactați cu detalii și vom face tot posibilul să vă ajutăm. De asemenea, aveți dreptul să contactați autoritatea locală de protecție a datelor.",
		content51: "Afacerea noastră este în continuă schimbare, iar declarația de confidențialitate va evolua. Vă recomandăm să verificați frecvent site-ul pentru ultimele actualizări. Dacă nu sunteți de acord cu modificările, trebuie să încetați utilizarea platformei imediat. Continuarea utilizării după publicarea noilor politici constituie acceptarea și acordul față de acestea. Cu excepția cazului în care este specificat altfel, această declarație de confidențialitate se aplică tuturor informațiilor despre dvs. și contul dvs. pe care le deținem.",
    },
    serviceAgreement: {
		title: "Acord de servicii",
		content1: "Acest site web este o platformă destinată utilizatorilor pentru tranzacționarea activelor digitale și oferirea de servicii conexe (denumite în continuare „serviciul” sau „serviciile”). Pentru ușurința exprimării în acest acord, site-ul se referă la sine prin „noi” sau alte pronume de persoana întâi. Orice persoană fizică sau juridică care accesează site-ul este considerată utilizator al site-ului, iar în acest acord, pentru ușurință, vom folosi „dumneavoastră” sau alte pronume de persoana a doua. Pentru comoditate, „noi” și „dumneavoastră” vor fi denumiți „părțile”, iar fiecare parte va fi denumită „parte”.",
		content2: "Notă importantă:",
		content3: "Vă atragem în mod special atenția:",
		content4: "1 Activele digitale nu sunt emise de nicio instituție financiară, companie sau acest site web.",
		content5: "2 Piața activelor digitale este nouă, neconfirmată și poate să nu crească;",
		content6: "3 Activele digitale sunt utilizate în mare parte de speculatori, utilizarea în piețele de retail și comerciale este relativ redusă; tranzacționarea activelor digitale implică riscuri foarte mari, fiind deschisă 24/7 fără limită de creștere sau scădere, iar prețurile pot fluctua puternic sub influența operatorilor de piață și a politicilor guvernamentale globale;",
		content7: "4 Dacă compania consideră, după propria evaluare, că ați încălcat acest acord sau că serviciile oferite în jurisdicția dumneavoastră sau modul dumneavoastră de utilizare sunt ilegale, compania are dreptul de a suspenda sau închide contul și/sau accesul la serviciile de tranzacționare a activelor digitale oferite de acest site. Este interzisă utilizarea serviciilor de tranzacționare a contractelor de către persoane din [China continentală, Taiwan, Israel, Irak, Bangladesh, Bolivia, Ecuador, Kârgâzstan, Sevastopol, Regatul Unit (utilizatori retail)]. Lista țărilor sau regiunilor poate fi modificată în funcție de politici și tipuri de produse, fără notificare separată. Vă rugăm să verificați periodic actualizările acestui acord.",
		content8: "Tranzacționarea activelor digitale este extrem de riscantă și nu este potrivită pentru majoritatea persoanelor. Înțelegeți și acceptați că tranzacționarea poate duce la pierderi parțiale sau totale, iar suma tranzacționată trebuie să fie în limita capacității dumneavoastră de asumare a pierderilor. Înțelegeți și acceptați riscurile derivate ale activelor digitale și, dacă aveți îndoieli, ar trebui să consultați un consilier profesionist. Pe lângă riscurile menționate, pot exista riscuri neprevăzute. Trebuie să evaluați cu atenție situația financiară și riscurile și să vă asumați toate pierderile rezultate, fără a ne putea trage la răspundere pentru acestea.",
		content9: "Avertisment:",
		content10: "1 Înțelegeți că acest site este doar o platformă pentru obținerea de informații despre active digitale, găsirea partenerilor de tranzacție, negocierea și efectuarea tranzacțiilor. Site-ul nu participă la tranzacțiile dumneavoastră, astfel că trebuie să verificați și să vă asumați responsabilitatea pentru autenticitatea, legalitatea și validitatea informațiilor și activelor digitale implicate.",
		content11: "2 Opiniile, știrile, discuțiile, analizele, prețurile, recomandările și alte informații de pe site sunt comentarii generale de piață și nu constituie recomandări de investiții. Nu ne asumăm responsabilitatea pentru pierderi directe sau indirecte rezultate din încrederea în aceste informații, inclusiv pierderi de profit.",
		content12: "3 Ne rezervăm dreptul de a modifica sau schimba conținutul în orice moment. Am luat măsuri rezonabile pentru acuratețea informațiilor, dar nu garantăm completitudinea sau acuratețea și nu răspundem pentru eventuale pierderi cauzate de întârzierea sau eșecul de transmitere a informațiilor pe site sau pe internet.",
		content13: "4 Utilizarea sistemelor de tranzacționare online implică riscuri, inclusiv defecțiuni software, hardware sau conexiuni internet. Deoarece nu putem controla fiabilitatea sau disponibilitatea internetului, nu suntem responsabili pentru distorsiuni, întârzieri sau eșecuri de conexiune.",
		content14: "5 Este interzisă utilizarea site-ului pentru spălare de bani, contrabandă, mită comercială sau alte activități ilegale. În caz de suspiciune, putem folosi orice măsuri legale, inclusiv blocarea conturilor și notificarea autorităților. Nu ne asumăm responsabilitatea pentru consecințe și ne rezervăm dreptul de a urmări răspunderea persoanelor implicate.",
		content15: "6 Este interzisă manipularea pieței sau alte activități neloiale. În cazul detectării unor astfel de practici, vom lua măsuri preventive precum avertismente, restricții de tranzacționare sau închiderea conturilor. Nu ne asumăm responsabilitatea pentru consecințe și ne rezervăm dreptul de a urmări răspunderea persoanelor implicate.",
		content16: "I. Dispoziții generale",
		content17: "1.1 „Acordul cu utilizatorul” (denumit în continuare „acest acord” sau „termeni și condiții”) include prezentul text, „Declarația de confidențialitate”, „Politica KYC și anti-spălare de bani” și alte reguli, declarații și instrucțiuni emise sau ce pot fi emise de site.",
		content18: "1.2 Înainte de a utiliza serviciile site-ului, trebuie să citiți cu atenție acest acord. Dacă aveți nelămuriri, consultați un avocat profesionist. Dacă nu sunteți de acord cu acordul sau modificările acestuia, trebuie să încetați utilizarea serviciilor sau accesarea site-ului imediat. Utilizarea continuă implică acceptarea completă a acestuia și a modificărilor ulterioare.",
		content19: "1.3 Prin completarea informațiilor și parcurgerea procesului de înregistrare, deveniți membru al site-ului (denumit „membru”). Prin apăsarea butonului „Accept” în timpul înregistrării sau prin utilizarea serviciilor site-ului, confirmați acceptarea completă și fără rezerve a termenilor acestui acord, care vă leagă legal, chiar fără semnătură scrisă.",
		content20: "1.4 După înregistrare, veți primi un cont și o parolă, pe care trebuie să le păstrați în siguranță. Sunteți responsabil pentru toate activitățile desfășurate prin contul dumneavoastră.",
		content21: "1.5 Doar membrii pot folosi platforma de tranzacționare și alte servicii dedicate membrilor; utilizatorii neînregistrați pot doar să navigheze și să acceseze serviciile disponibile pentru public.",
		content22: "1.6 Prin înregistrare și utilizare, confirmați că:",
		content23: "1.6.1 Acceptați toate termenii și condițiile acestui acord.",
		content24: "1.6.2 Aveți cel puțin 18 ani sau vârsta legală de contract în jurisdicția dumneavoastră și acționați conform legilor locale; aveți capacitatea legală de a încheia tranzacții și utiliza serviciile site-ului.",
		content25: "1.6.3 Garantati că toate activele digitale pe care le tranzacționați vă aparțin legal.",
		content26: "1.6.4 Vă asumați întreaga responsabilitate pentru toate tranzacțiile și activitățile dumneavoastră, inclusiv câștiguri și pierderi.",
		content27: "1.6.5 Informațiile oferite la înregistrare sunt adevărate și exacte.",
		content28: "1.6.6 Vă angajați să respectați toate legile relevante, inclusiv raportarea câștigurilor fiscale.",
		content29: "1.6.7 Nu veți desfășura niciodată activități care să afecteze negativ site-ul sau compania, indiferent dacă sunt legate de serviciile oferite.",
		content30: "1.6.8 Acest acord reglementează relația dintre dumneavoastră și noi și nu acoperă relațiile legale dintre utilizatorii site-ului sau între alți terți în legătură cu tranzacțiile cu active digitale.",
		content31: "II. Modificarea acordului",
		content32: "Ne rezervăm dreptul de a revizui periodic acest acord și de a anunța modificările prin publicarea pe site, fără a notifica individual utilizatorii. Data ultimei modificări va fi afișată în secțiunea [Ultima actualizare] a acestui acord. Odată publicate pe site, modificările intră în vigoare imediat. Vă recomandăm să verificați periodic actualizările acestui acord. Dacă nu sunteți de acord cu modificările, trebuie să încetați imediat utilizarea serviciilor site-ului; continuarea utilizării serviciilor implică acceptarea acordului modificat.",
		content33: "III. Înregistrarea",
		content34: "3.1 Eligibilitatea pentru înregistrare",
		content35: "Confirmați și garantați că atunci când finalizați procesul de înregistrare sau utilizați serviciile site-ului în alte moduri permise, sunteți o persoană fizică, juridică sau altă organizație cu capacitatea legală de a încheia acest acord și de a utiliza serviciile site-ului conform legilor aplicabile. Prin apăsarea butonului de acceptare a înregistrării, confirmați că dumneavoastră sau reprezentantul dumneavoastră autorizat a acceptat acest acord și utilizează serviciile site-ului în numele dumneavoastră. Dacă nu dețineți această capacitate, dumneavoastră și reprezentantul autorizat sunteți responsabili pentru toate consecințele și ne rezervăm dreptul de a anula sau bloca permanent contul dumneavoastră și de a solicita răspunderea legală a dumneavoastră și a reprezentantului.",
		content36: "3.2 Scopul înregistrării",
		content37: "Confirmați și garantați că înregistrarea pe site nu are scopul de a încălca legile, reglementările sau de a perturba ordinea tranzacțiilor digitale a site-ului.",
		content38: "3.3 Procesul de înregistrare",
		content39: "3.3.1 Sunteți de acord să furnizați adresa de e-mail, numărul de telefon și alte informații valide cerute în pagina de înregistrare. Puteți folosi aceste informații sau alte metode permise pentru autentificare. Dacă este necesar, conform legilor locale, trebuie să furnizați numele real, documentele de identitate și alte informații cerute de legislație, politica de confidențialitate și KYC/AML, menținând datele actualizate, complete și exacte. Sunteți responsabil pentru corectitudinea și veridicitatea acestor date și pentru orice pierderi sau prejudicii cauzate de informațiile incorecte.",
		content40: "3.3.2 Dacă legislația din țara sau regiunea dumneavoastră impune identificarea numărului de telefon, sunteți de acord să furnizați un număr înregistrat pe numele dumneavoastră. Pierderile sau prejudiciile cauzate de neconformare sunt în responsabilitatea dumneavoastră.",
		content41: "3.3.3 După furnizarea corectă și verificarea datelor, veți primi un cont și parolă, considerându-se înregistrarea finalizată, putând să vă autentificați și să deveniți membru.",
		content42: "3.3.4 Sunteți de acord să primiți e-mailuri și mesaje legate de administrarea și operarea site-ului.",
		content43: "IV. Servicii",
		content44: "Site-ul oferă platforma online pentru tranzacționarea activelor digitale și servicii conexe (inclusiv, dar fără a se limita la, tranzacționarea activelor digitale).",
		content45: "4.1 Descrierea serviciilor",
		content46: "4.1.1 Aveți dreptul să vizualizați cotațiile și informațiile de tranzacționare în timp real și să transmiteți ordine de tranzacționare și să finalizați tranzacțiile.",
		content47: "4.1.2 Aveți dreptul să accesați informațiile contului de membru și să utilizați funcțiile disponibile.",
		content48: "4.1.3 Aveți dreptul să participați la activitățile organizate conform regulamentului publicat.",
		content49: "4.1.4 Alte servicii promise de site.",
		content50: "4.2 Reguli de utilizare a serviciilor - vă angajați să respectați următoarele:",
		content51: "4.2.1 Respectați toate legile, reglementările și politicile relevante, asigurând legalitatea sursei activelor digitale din contul dumneavoastră și nefolosind serviciile pentru activități ilegale sau care prejudiciază drepturile site-ului sau terților, inclusiv, dar fără a se limita la, transmiterea de informații ilegale, frauduloase, piramidale sau cu conținut dăunător, folosirea neautorizată a antetului de e-mail al site-ului.",
		content52: "4.2.2 Păstrați și utilizați responsabil contul, parola, parola de fonduri, numărul de telefon și codurile de verificare. Sunteți responsabil pentru toate acțiunile efectuate prin contul dumneavoastră. În caz de utilizare neautorizată, anunțați imediat site-ul pentru suspendarea serviciilor. Site-ul va acționa rezonabil în timp util, dar nu răspunde pentru daunele apărute înainte de luarea măsurilor. Nu transferați contul altor persoane fără acordul nostru.",
		content53: "4.2.3 Vă asumați responsabilitatea pentru toate activitățile efectuate sub contul dumneavoastră, inclusiv divulgarea informațiilor, acceptarea de termeni, reînnoiri de acorduri sau achiziții de servicii.",
		content54: "4.2.4 Nu interferați cu tranzacțiile digitale, nu perturbați ordinea tranzacțiilor, nu afectați funcționarea site-ului sau utilizarea altor utilizatori și nu defăimați site-ul prin mijloace false.",
		content55: "4.2.5 În caz de conflicte între utilizatori, nu solicitați informații site-ului în afara căilor legale sau administrative.",
		content56: "4.2.6 Toate taxele fiscale și cele aferente hardware, software, servicii sau alte costuri sunt în responsabilitatea dumneavoastră.",
		content57: "4.2.7 Respectați prezentul acord și alte reguli și instrucțiuni emise și aveți dreptul să încetați utilizarea serviciilor în orice moment.",
		content58: "4.3 Regulile produselor",
		content59: "4.3.1 Navigarea informațiilor despre tranzacții",
		content60: "Când navigați informațiile despre tranzacții pe acest site, trebuie să citiți cu atenție toate detaliile incluse, cum ar fi prețul, volumul ordinelor, taxele, direcția cumpărării sau vânzării. Trebuie să acceptați complet conținutul înainte de a apăsa butonul pentru a efectua tranzacția.",
		content61: "4.3.2 Vizualizarea detaliilor tranzacțiilor",
		content62: "Puteți vizualiza istoricul tranzacțiilor prin contul dumneavoastră.",
		content63: "V. Drepturile și obligațiile site-ului",
		content64: "5.1 Dacă nu îndepliniți condițiile de eligibilitate pentru înregistrare conform acestui acord, site-ul are dreptul să vă refuze înregistrarea sau să vă anuleze contul deja înregistrat și să urmărească responsabilitatea dumneavoastră și a reprezentantului autorizat. De asemenea, site-ul își rezervă dreptul de a decide, în alte situații, dacă acceptă înregistrarea dumneavoastră.",
		content65: "5.2 Site-ul poate suspenda sau închide contul dumneavoastră și al conturilor asociate dacă consideră că nu sunteți potrivit pentru investiții cu risc ridicat.",
		content66: "5.3 Site-ul poate suspenda sau închide conturile utilizate de persoane care nu sunt titularul inițial al contului.",
		content67: "5.4 Dacă site-ul suspectează că informațiile furnizate de dumneavoastră sunt incorecte, false, expirate sau incomplete, poate solicita corectarea sau actualizarea acestora sau poate suspenda ori închide serviciile oferite.",
		content68: "5.5 Site-ul are dreptul să corecteze orice informație eronată afișată pe platformă.",
		content69: "5.6 Site-ul își rezervă dreptul de a modifica, suspenda sau înceta serviciile fără notificare prealabilă; încetarea serviciilor va intra în vigoare din momentul anunțului publicat pe site.",
		content70: "5.7 Site-ul va lua măsurile tehnice și administrative necesare pentru a asigura funcționarea normală și securitatea platformei, oferind un mediu sigur pentru tranzacțiile digitale și menținând ordinea acestora.",
		content71: "5.8 Dacă nu vă conectați la cont timp de un an consecutiv, site-ul poate anula contul și numele de utilizator poate fi eliberat pentru alți utilizatori.",
		content72: "5.9 Site-ul ia măsuri pentru a proteja securitatea activelor digitale și vă va notifica anticipat în caz de riscuri de securitate anticipate în contul dumneavoastră.",
		content73: "5.10 Site-ul are dreptul de a șterge conținutul care încalcă legea sau regulile platformei fără notificare prealabilă.",
		content74: "5.11 Site-ul poate solicita informații suplimentare conform legislației din țara/regiunea dumneavoastră și poate suspenda sau închide serviciile parțial sau total în conformitate cu reglementările locale; aveți obligația să cooperați.",
		content75: "5.12 Site-ul poate închide contul dumneavoastră după o notificare cu șapte zile lucrătoare prealabile. În această perioadă puteți anula ordinele sau închide pozițiile; dacă nu faceți acest lucru, site-ul va forța anularea/inchiderea și va returna activele digitale rămase.",
		content76: "5.13 Pentru protecția utilizatorilor, site-ul are dreptul să ajusteze produsele în circumstanțe speciale (ex. defecțiuni de sistem, piață extremă), inclusiv efectuarea încheierii anticipate a contractelor conform anunțurilor publicate.",
		content77: "VI. Despăgubiri",
		content78: "6.1 Răspunderea noastră pentru daune directe este limitată la suma taxelor de serviciu plătite de dumneavoastră pentru serviciile folosite în ultimele trei (3) luni.",
		content79: "6.2 În cazul încălcării acordului sau a legilor, trebuie să ne despăgubiți cu cel puțin 2 milioane USD și să acoperiți toate costurile (inclusiv cheltuieli legale); dacă suma nu acoperă pagubele reale, trebuie să acoperiți diferența.",
		content80: "VII. Dreptul de a solicita măsuri de ordin",
		content81: "Atât noi, cât și dumneavoastră, recunoaștem că remedii obișnuite pot să nu acopere integral pierderile cauzate de încălcarea acordului, astfel putem solicita măsuri de ordin și alte remedii permise de lege.",
		content82: "VIII. Limitarea răspunderii și exonerarea",
		content83: "8.1 Înțelegeți și acceptați că în niciun caz noi nu răspundem pentru:",
		content84: "8.1.1 Pierderi de venit;",
		content85: "8.1.2 Pierderi din profituri sau contracte;",
		content86: "8.1.3 Pierderi cauzate de întreruperea afacerii;",
		content87: "8.1.4 Pierderi de economii anticipate;",
		content88: "8.1.5 Pierderi cauzate de probleme de informații;",
		content89: "8.1.6 Pierderi de oportunități, bună reputație sau imagine;",
		content90: "8.1.7 Coruperea sau pierderea datelor;",
		content91: "8.1.8 Costul achiziționării unui produs sau serviciu alternativ;",
		content92: "8.1.9 Orice pierderi sau daune indirecte, speciale sau incidentale cauzate de încălcări (inclusiv neglijență), nerespectare a contractului sau orice alte cauze, indiferent dacă acestea puteau fi rezonabil prevăzute de noi și indiferent dacă am fost informați anterior despre posibilitatea acestor pierderi sau daune.",
		content93: "8.1.1 până la 8.1.9 sunt independente una de cealaltă.",
		content94: "8.2 Înțelegeți și acceptați că nu ne asumăm răspundere pentru daune cauzate de oricare dintre următoarele situații:",
		content95: "8.2.1 Dacă tranzacțiile dumneavoastră specifice sunt în mod semnificativ ilegale sau în încălcare a acordului.",
		content96: "8.2.2 Comportamentul dumneavoastră pe site este suspectat a fi ilegal sau imoral.",
		content97: "8.2.3 Costuri sau pierderi cauzate de cumpărarea sau obținerea datelor, informațiilor sau efectuarea tranzacțiilor prin intermediul serviciilor site-ului.",
		content98: "8.2.4 Neînțelegeri privind serviciile oferite de site.",
		content99: "8.2.5 Alte pierderi legate de serviciile oferite de site, care nu au fost cauzate de noi.",
		content100: "8.3 Nu ne asumăm răspundere pentru pierderi cauzate de întreținerea echipamentelor de rețea, defecțiuni ale conexiunii de internet, defecțiuni hardware sau software, întreruperi de curent, condiții meteo, accidente, greve, revolte, insuficiența resurselor, dezastre naturale, război, acțiuni guvernamentale, ordine ale autorităților judiciare sau administrative, cauze externe sau necontrolabile.",
		content101: "8.4 Nu garantăm că toate informațiile, programele sau conținutul de pe site sunt complet sigure, libere de viruși, malware sau alte programe dăunătoare; utilizarea serviciilor și descărcarea oricărui conținut se face pe riscul dumneavoastră.",
		content102: "8.5 Nu ne asumăm responsabilitatea pentru conținutul, produsele sau serviciile terților accesate prin linkuri pe site; utilizarea acestor servicii este pe riscul dumneavoastră.",
		content103: "8.6 Nu oferim garanții explicite sau implicite privind serviciile site-ului, inclusiv dar fără a se limita la acuratețea, continuitatea, fiabilitatea sau adecvarea acestora; utilizarea serviciilor este pe riscul dumneavoastră. Nu garantăm valoarea sau stabilitatea prețurilor activelor digitale; tranzacțiile se fac pe răspunderea dumneavoastră.",
		content104: "8.7 Garanțiile și declarațiile noastre din prezentul acord sunt unice și exclusive, înlocuind orice alte garanții sau declarații, scrise sau orale, iar acestea nu se extind la terți.",
		content105: "8.8 Nu renunțăm la niciun drept legal de a limita sau exclude răspunderea noastră în cea mai mare măsură permisă de lege.",
		content106: "8.9 Prin înregistrare, confirmați acceptarea tuturor operațiunilor făcute conform prezentului acord și înțelegeți că toate riscurile asociate sunt pe răspunderea dumneavoastră.",
		content107: "IX. Terminarea acordului",
		content108: "9.1 Site-ul poate înceta toate serviciile oferite în conformitate cu acest acord, moment în care acordul încetează.",
		content109: "9.2 După încetarea acordului, nu puteți solicita continuarea serviciilor sau păstrarea și dezvăluirea datelor contului, sau transmiterea informațiilor nedeclarate anterior.",
		content110: "9.3 Terminarea acordului nu afectează drepturile părților privind răspunderea pentru încălcări comise anterior.",
		content111: "X. Proprietatea intelectuală",
		content112: "10.1 Toate drepturile de proprietate intelectuală asupra conținutului site-ului (logo, baze de date, design, text, grafică, software, fotografii, videoclipuri, muzică etc.) aparțin site-ului. Nu aveți dreptul să copiați, modificați, trimiteți sau utilizați aceste materiale în scopuri comerciale.",
		content113: "10.2 Toate drepturile asupra numelui site-ului, inclusiv reputația, marca și logo-ul, aparțin companiei.",
		content114: "10.3 Prin acceptarea acordului, cedați site-ului drepturile de autor asupra oricărei informații postate de dumneavoastră pe site, inclusiv drepturile de reproducere, distribuție, închiriere, expunere, interpretare, difuzare, comunicare în rețea, adaptare, traducere, compilare și alte drepturi transferabile, în mod gratuit și exclusiv, permițând site-ului să acționeze împotriva încălcărilor.",
		content115: "10.4 Nu puteți folosi ilegal drepturile de proprietate intelectuală ale site-ului sau ale altora și nu puteți publica informațiile de pe site pe alte site-uri sau media fără autorizare.",
		content116: "XI. Protecția informațiilor",
		content117: "Se aplică prevederile separate ale Politicii de Confidențialitate afișate de site.",
		content118: "XII. Calcul",
		content119: "Toate calculele tranzacțiilor sunt verificate de noi și metodele de calcul sunt publicate, dar nu garantăm absența erorilor sau interferențelor în utilizarea site-ului.",
		content120: "XIII. Controlul exporturilor",
		content121: "Înțelegeți că nu puteți exporta, reexporta, importa sau transfera materiale de pe site (inclusiv software) în mod ilegal; sunteți obligați să raportați orice încălcare și să cooperați cu noi.",
		content122: "XIV. Cesionarea",
		content123: "Drepturile și obligațiile din prezentul acord sunt obligatorii pentru cesionari, moștenitori și administratori. Nu puteți cesiona drepturile fără acordul nostru, dar noi putem cesiona oricând drepturile și obligațiile noastre și vă vom notifica.",
		content124: "XV. Divizibilitatea",
		content125: "Dacă o clauză a acestui acord este declarată nulă sau inaplicabilă, celelalte clauze rămân valabile.",
		content126: "XVI. Relația de agenție",
		content127: "Nicio prevedere a acestui acord nu creează o relație de agent, fiduciar sau reprezentant între părți, cu excepția celor prevăzute expres.",
		content128: "XVII. Renunțare",
		content129: "Noi sau dumneavoastră nu renunțăm la dreptul de a urmări răspunderea pentru încălcările prezentului acord; renunțarea la un drept nu va fi interpretată ca renunțare la alte drepturi sau remedii, iar neexercitarea unui drept nu înseamnă renunțare la acesta.",
		content130: "XVIII. Titluri",
		content131: "Toate titlurile sunt doar pentru ușurința exprimării și nu extind sau limitează conținutul ori aria clauzelor prezentului acord.",
		content132: "XIX. Legea aplicabilă",
		content133: "19.1 Înainte de a iniția orice dispută sau revendicare, confirmați și acceptați că veți contacta site-ul prin email pentru o rezolvare informală; vom încerca să soluționăm problema intern cât mai curând posibil; ambele părți sunt de acord să rezolve disputa prin negocieri de bună credință (conținutul discuțiilor va fi confidențial și protejat conform regulilor aplicabile, neputând fi folosit ca probă în proceduri legale).",
		content134: "19.2 În cazul oricărei dispute, neînțelegeri sau revendicări privind existența, validitatea, interpretarea, executarea, încălcarea sau încetarea acestui acord sau legate de el („Disputa”), ambele părți vor supune disputa Curții Internaționale de Arbitraj a Camerei de Comerț Internaționale (ICC), conform Regulilor de Arbitraj ICC aplicabile la momentul respectiv. Locul arbitrajului este Belize, iar legea aplicabilă se va determina conform Regulilor ICC. În absența unui acord contrar, va fi numit un singur arbitru, care are competență exclusivă să decidă asupra jurisdicției sale, inclusiv asupra valabilității acordului de arbitraj și a arbitrabilității cererilor și excepțiilor. Procedura va fi în limba engleză. Arbitrajul va genera o decizie scrisă cu explicații rezonabile, iar decizia este finală și obligatorie pentru părți și poate fi executată în orice instanță competentă.",
		content135: "XX. Efectul și interpretarea acordului",
		content136: "20.1 Prezentul acord intră în vigoare la momentul în care acceptați înregistrarea pe pagina site-ului și obțineți contul și parola, fiind obligatoriu atât pentru site cât și pentru dumneavoastră.",
		content137: "20.2 Dreptul exclusiv de interpretare finală a acestui acord aparține site-ului.",
		content138: "Politica de Cunoaștere a Clientului (KYC) și Anti-Spălare a Banilor (AML)",
		content139: "I. Introducere",
		content140: "1.1 Ne angajăm să respectăm cu diligență legile și reglementările KYC și AML, fără a le încălca intenționat. În limite rezonabile, vom lua măsuri și tehnologii necesare pentru a vă oferi servicii sigure și a vă proteja de pierderi cauzate de spălarea banilor de către persoane suspecte.",
		content141: "1.2 Politica noastră KYC și AML este un sistem internațional complex care acoperă diferite jurisdicții aplicabile pentru dumneavoastră.",
		content142: "II. Politica KYC și AML include:",
		content143: "2.1 Emiterea și actualizarea regulată a politicii pentru a respecta standardele legale aplicabile;",
		content144: "2.2 Emiterea și actualizarea unor principii și reguli de funcționare a site-ului, iar personalul nostru le va aplica în serviciu;",
		content145: "2.3 Crearea și implementarea unor proceduri interne de monitorizare și control al tranzacțiilor, inclusiv verificări stricte ale identității și echipe dedicate AML;",
		content146: "2.4 Aplicarea unei abordări bazate pe risc pentru verificarea și supravegherea continuă a clienților;",
		content147: "2.5 Revizuirea și inspecția periodică a tranzacțiilor realizate;",
		content148: "2.6 Raportarea tranzacțiilor suspecte autorităților competente;",
		content149: "2.7 Păstrarea documentelor justificative pentru identitate, adresă și tranzacții pentru cel puțin șase ani; în cazul prezentării către autorități, nu veți fi notificat separat.",
		content150: "III. Informații de identificare și verificare",
		content151: "3.1 Informații de identificare",
		content152: "3.1.1 În funcție de jurisdicție și tipul de entitate, colectăm informații diferite. Pentru persoane fizice, în principiu, colectăm:",
		content153: "Informații personale: nume, adresă (inclusiv permanentă, dacă este diferită), data nașterii, naționalitate și alte informații disponibile. Verificarea identității se face cu documente oficiale sau echivalente, cum ar fi pașaport, carte de identitate sau alte documente cerute de jurisdicție. Adresa este verificată prin metode adecvate, cum ar fi facturi utilități sau registre electorale.",
		content154: "Fotografie validă: înainte de înregistrare, trebuie să furnizați o fotografie cu documentul de identitate ținut la piept;",
		content155: "Contact: număr de telefon/mobil și/sau adresă de email validă.",
		content156: "3.1.2 Pentru companii sau alte entități legale, colectăm informații pentru identificarea beneficiarului real al contului/trustului.",
		content157: "Documente de înregistrare ale companiei; copii ale statutului și memorandumului; dovezi detaliate privind structura acționariatului și autoritățile care decid deschiderea și gestionarea contului, rezoluții ale consiliului de administrație; documente de identitate pentru directori, acționari majori și semnatarii autorizați; adresa sediului principal și adresa de corespondență, dacă este diferită. Clienții cu sediul local diferit față de sediul principal sunt considerați cu risc ridicat și trebuie să furnizeze documente suplimentare.",
		content158: "Alte certificări și documente solicitate conform jurisdicției și entității, precum și cele pe care le considerăm necesare.",
		content159: "3.1.3 Acceptăm doar documente în limbile engleză sau chineză; în alte cazuri, trebuie să furnizați traduceri autorizate în engleză.",
		content160: "3.2 Verificare",
		content161: "3.2.1 Solicităm toate paginile documentului de identitate.",
		content162: "3.2.2 Solicităm o fotografie cu documentul ținut la piept.",
		content163: "3.2.3 Copiile documentelor trebuie verificate cu originale, însă sunt acceptate copii certificate de persoane autorizate (ambasade, notari, etc.).",
		content164: "3.2.4 Pentru identificarea beneficiarilor reali și controlul contului, verificăm cine deține și controlează clientul direct. Pentru companii, acționarii mari (de ex., cei cu peste 10% drepturi de vot) trebuie verificați; acționarii cu peste 25% sunt considerați risc normal, cei cu peste 10% sau drepturi de vot mai mari sunt considerați risc ridicat și trebuie verificați suplimentar.",
		content165: "IV. Monitorizarea tranzacțiilor",
		content166: "4.1 Stabilim și ajustăm periodic limitele zilnice maxime pentru tranzacții și retrageri, pe baza securității și a situației reale a tranzacțiilor;",
		content167: "4.2 Dacă tranzacțiile sunt frecvente și concentrate într-un singur utilizator înregistrat sau există situații neobișnuite, echipa noastră profesională va evalua și decide dacă acestea sunt suspecte;",
		content168: "4.3 În cazul în care, la discreția noastră, o tranzacție este considerată suspectă, putem lua măsuri restrictive precum suspendarea sau refuzul tranzacției, sau, dacă este posibil, inversarea rapidă a acesteia, raportând autorităților competente, fără a vă notifica pe dumneavoastră;",
		content169: "4.4 Ne rezervăm dreptul de a refuza cererile de înregistrare provenite din jurisdicții care nu respectă standardele internaționale anti-spălare a banilor sau de la persoane considerate politicieni expuși, și de a suspenda sau încheia tranzacții suspecte după propria noastră evaluare, fără a încălca astfel obligațiile sau responsabilitățile față de dumneavoastră.",
    },
    register: {
		formTitle1: "Creează",
		formTitle2: "Înregistrează-te cu adresa ta de e-mail sau numărul de telefon",
		formTitle3: "Cont",
		field1: "Cod de verificare",
		field2: "Obține",
		field3: "Confirmă parola",
		field4: "Cod invitație",
		field41: "(Opțional)",
		field5: "Am citit și sunt de acord cu",
		field6: "Termenii serviciului",
		placeholder1: "Introduceți codul de verificare",
		content7: "Introduceți codul de verificare",
		content12: "Introduceți numărul de telefon",
		content13: "Introduceți parola",
		content14: "Introduceți adresa de e-mail",
		content18: "Introduceți din nou parola",
		content19: "Vă rugăm să acceptați termenii serviciului",
		content20: "Introduceți un cod de verificare corect",
		content23: "Nu ați primit încă codul de verificare?",
		content24: "Introduceți codul de mai jos",
		registerSuccess: "Înregistrare reușită",
		content25: "Parolele nu se potrivesc",
		content26: "Introduceți o adresă de e-mail validă",
		content27: "Parola a fost resetată cu succes"
    },
    download: {
		content1: "Tranzacționează oricând, oriunde",
		content2: "Compatibil perfect cu mai multe dispozitive, satisfacerea nevoilor de tranzacționare în diverse scenarii",
		content3: "Vizualizați oricând piețele în timp real",
		content4: "Cumpărați și vindeți BTC, ETH, XRP și alte active digitale cu ușurință",
		content5: "Primiți alerte de preț pentru criptomonedele de care sunteți interesat",
		content6: "Consultați prețurile spot, futures și opțiuni ale Bitcoin",
		content7: "Comparați prețurile criptomonedelor între diferite platforme de schimb",
		title: "Descărcare",
		install: "Instrucțiuni de instalare",
		one: "1. Permiteți descărcarea profilului de configurare",
		two: "2. Profilul de configurare a fost descărcat",
		three: "3. Intrați în [Setări] > [General] pe telefon",
		four: "4. Profil și gestionare dispozitive",
		five: "5. Apăsați pe profilul de configurare",
    },
    identity: {
        noAuthentication: {
			title: "Verificare de bază",
			pleaseSelectYourCountry: "Vă rugăm să selectați țara dvs.",
			name: "Nume",
			enterName: "Vă rugăm să introduceți numele dvs.",
			city: "Orașul de reședință",
			enterCity: "Vă rugăm să introduceți orașul dvs.",
			IDNumber: "Numărul actului de identitate",
			enterIDNumber: "Vă rugăm să introduceți numărul actului de identitate",
        },
        noAdvancedAuthentication: {
			title: "Verificare avansată",
			infoCountry: "Țară/Regiune",
			infoName: "Nume",
			infoNumber: "Numărul actului de identitate",
			infoAddress: "Adresă",
        },
		text: "Nesupus verificării",
		recertification: "Reverificare",
		certification: "Verificare",
		authenticationInProgress: "Verificat",
		inAuthentication: "În curs de verificare",
		uploadTheFrontOfTheDocument: "Încarcă partea din față a documentului",
		uploadTheReverseSideOfTheDocument: "Încarcă partea din spate a documentului",
		uploadAPhotoOfAHandHeldID: "Încarcă partea din spate a documentului", // （注：此处中文重复，翻译按原意）
		pleaseUpload: "Vă rugăm ",
		pleaseCompleteOrdinaryCertificationFirst: "Trebuie să așteptați aprobarea verificării de bază",
		refused: "Respins",
		reason: "Motiv",
		succeeded: "Succes",
		uploading: "Se încarcă",
		newTitle: "Selectați țara/regiunea de emitere a actului de identitate",
		pleaseOrdinaryCertificationFirst: "Vă rugăm să efectuați mai întâi verificarea de bază",
		text1: "Modifică avatarul",
		text2: "Poreclă",
		text3: "Cont",
		text4: "Modificare poreclă",
		text5: "Poreclă nouă",
		text6: "Introduceți noua dvs. poreclă",
		text7: "Parolă veche",
		text8: "Introduceți parola veche",
		text9: "Parolă nouă",
		text10: "Introduceți noua parolă",
		text11: "Confirmare parolă",
		text12: "Reintroduceți noua parolă",
		text13: "Email nou",
		text14: "Cod de verificare",
		text15: "Vă rugăm să introduceți codul de verificare",
		text16: "Numărul dvs. de telefon",
		text17: "Număr de telefon nou",
		text18: "Vă rugăm să introduceți noul număr de telefon",
		text19: "Cod de verificare prin SMS",
		text20: "Verificare de bază",
		text21: "Vă rugăm să verificați informațiile dvs. de identitate",
		text22: "Țara în care locuiți",
		text23: "Orașul în care locuiți",
		text24: "Introduceți orașul în care locuiți",
		text25: "Introduceți numele dvs.",
		text26: "Numărul documentului dvs.",
		text27: "Introduceți numărul documentului",
		text28: "Poză față a documentului",
		text29: "Faceți clic pentru a încărca documentul dvs.",
		text30: "Reîncărcați",
		text31: "Încărcați",
		text32: "Poză verso a documentului",
		text33: "Faceți clic pentru a încărca partea din spate a documentului",
		text34: "Ați legat deja autentificatorul Google",
		text35: "Cheie",
		text36: "Introduceți codul de verificare Google",
		text37: "Trimite",
		text38: "Nu poate fi gol",
		text39: "Formatul adresei de email este incorect",
		text40: "Cele două parole nu corespund",
		text41: "Copiere reușită",
		text42: "Copiere eșuată",
		text43: "Modificare avatar",
		text44: "Modificare parolă",
		text45: "Legare email",
		text46: "Modificare email",
		text47: "Legare număr de telefon",
		text48: "Modificare număr de telefon",
		text49: "Verificare Google",
		text50: "Legați autentificatorul Google",
		text51: "Introduceți codul Google",
		text52: "Salvați",
		text53: "Confirmați trimiterea",
		text54: "Modifică",
		text55: "Leagă",
		text56: "Dezactivează verificarea Google",
		text57: "Următorul pas",
		text58: "Finalizat",
		text59: "Verificarea Google a fost legată",
		text60: "Verificarea Google a fost delgată",
		text61: "Verificarea de bază a fost trimisă",
		text62: "Verificarea avansată a fost trimisă",
		text63: "Imaginea nu a fost încărcată",
		text64: "Retrimite",
		text65: "Introduceți porecla",
		text66: "Porecla a fost salvată cu succes",
		text67: "Imaginea nu a fost încă încărcată",
		text68: "Parola a fost schimbată cu succes",
		text69: "Emailul a fost schimbat cu succes",
		text70: "Avatarul a fost salvat cu succes",
		text71: "Încărcați imaginea",
		text72: "Adresa dvs. de email",
		text73: "Introduceți noua adresă de email",
		text74: "Numele dvs.",
		text75: "Du-te la verificare",
		text76: "Vă rugăm să verificați fotografia dvs. cu documentul ținut în mână"
    },
    retrievePassword: {
		formTitle1: "Resetează parola",
		formTitle2: "Pentru siguranța activelor dvs., tranzacțiile sunt interzise timp de 24 de ore după modificarea parolei.",
		formTitle3: "Recuperare parolă",
		formTitle4: "Confirmă modificarea",
		formTitle5: "Introduceți parola veche",
		formTitle6: "Introduceți parola nouă"
    },
    home: {
		title1: "Cea mai populară platformă de tranzacționare a criptomonedelor",
		title3: "De ce ",
		title4: " este o platformă blockchain open-source de înaltă performanță, concepută pentru a susține și opera infrastructura digitală sigură, conformă și predictibilă.",
		field1: "Platformă de tranzacționare consacrată",
		field2: "Servicii financiare pentru active digitale",
		field3: "Zeci de milioane de utilizatori",
		field4: "Fonduri multiple de protecție a investitorilor",
		field5: "Tranzacționare rapidă",
		field6: "CME Group poate executa ordinele cu o latență ultra-redusă pentru o experiență de tranzacționare supremă.",
		title5: "Tendințe de piață",
		title6: "Vezi mai mult",
		table1: "Monedă",
		table2: "Preț recent",
		table3: "24H Schimbare",
		table4: "Volum 24H",
		table5: "Valoare tranzacționată 24H",
		table6: "Cotații",
		title7: "Despre ",
		title8: " se angajează să ofere utilizatorilor cele mai avansate instrumente de tranzacționare, tehnologie inovatoare și servicii clienți de neegalat.",
		title9: "Industria activelor digitale evoluează rapid; doar o viziune de perspectivă și progresul continuu pot ține pasul cu inovațiile tehnologice.",
		title901: " oferă servicii avansate de tranzacționare a activelor digitale pentru utilizatorii noștri și furnizorii globali de lichiditate.",
		title10: "Credem cu tărie că fiecare utilizator merită cea mai bună experiență de tranzacționare.",
		title11: "Siguranță de încredere",
		title12: "Măsurile noastre complexe de securitate și fondul SAFU protejează activele dvs. digitale de orice risc.",
		title13: "Cele mai bune comisioane de tranzacționare",
		title14: "Tarife favorabile, beneficii VIP competitive, servicii de cea mai înaltă calitate.",
		title15: "Asistență clienți 24/7",
		title16: "Suport non-stop 24/7, gata să răspundem imediat la întrebările dvs.",
		title17: "Tranzacționare fără comision",
		title18: "Tranzacționați criptomonede folosind mai multe metode de plată, fără comisioane, în siguranță și rapid.",
		title19: "Tranzacționați oriunde, oricând",
		title20: "Compatibilitate perfectă pe mai multe dispozitive, adaptabil pentru toate scenariile de tranzacționare",
		title21: "Vizualizați cotații în timp real în orice moment",
		title22: "Cumpărați și vindeți cu ușurință BTC, ETH, XRP și alte active digitale",
		title23: "Primiți alerte de preț pentru criptomonedele care vă interesează",
		title24: "Consultați prețurile spot, futures și opțiuni ale Bitcoin",
		title25: "Comparați prețurile criptomonedelor pe diverse platforme de schimb",
		title26: "Înregistrează-te acum",
		title27: "USD",
		title28: "Volumul tranzacționat în 24 de ore",
		title29: "Furnizor agregat de lichiditate",
		title30: "Utilizatori",
		title31: "Mai mult",
		title32: "Binance Loan adaugă CTSI&KSM ca active colaterale și lansează reduceri la dobânzile BUSD&USDT!",
		title33: "Avantajele noastre",
		title34: "Securitate și stabilitate",
		title35: "Echipă tehnică de top, protecție completă, motor de tranzacționare de mare viteză dezvoltat intern, funcționare stabilă chiar și la un volum mare de tranzacții.",
		title36: "Profesionalism și conformitate",
		title37: "Echipă de operare cu experiență în blockchain și finanțe, licențe conforme pentru tranzacționare de active digitale, acoperire 100% a fondurilor.",
		title38: "Utilizatorii pe primul loc",
		title39: "Prezență globală, suport în mai multe limbi, funcționare non-stop 24/7, comunitate solidă și servicii profesionale pentru clienți.",
		title40: "Performanță ridicată",
		title41: "300.000 de tranzacții pe secundă, timp de răspuns sub 1 milisecundă.",
		title42: "Despre noi",
		title43: "Tranzacționează oriunde și oricând",
		title44: "Compatibilitate perfectă cu mai multe dispozitive, adaptabil în orice scenariu de tranzacționare",
		title45: "(Scanează codul pentru a descărca)",
		title46: "Știri despre criptomonede",
		title47: "Partenerii noștri",
		title48: "Top scăderi",
		title49: "Volum 24h",
		title50: "Variație 24h"
    },
    quotation: {
		marketTrading: "Cotații",
		turnover: "Volum tranzacționat",
		optional: "Favorite",
		contractMarket: "Piața contractelor",
		currencyPair: "Pereche valutară",
		latestPrice: "Preț de închidere",
		upsAndDowns: "Variație procentuală",
		highest: "Maxim",
		lowest: "Minim",
		transactionAmount: "Valoare tranzacționată",
		operate: "Operațiune",
		buy: "Tranzacționează",
		topTurnovers: "Top volum tranzacționat",
		topGainers: "Top creșteri",
		tradingPair: "Pereche de tranzacționare",
		buyOrder: "Ordine de cumpărare",
		sellOrder: "Ordine de vânzare"
    },
    accountChange: {
		demo: "Simulare",
		realAccount: "Cont real",
		demoAccount: "Cont simulare",
		accountRole: "Rolul contului",
		pleaseSelect: "Vă rugăm să selectați",
		AccountChangeType: "Tip modificare cont",
		AccountType: "Tip cont",
		currencyType: "Tip monedă",
		allType: "Toate tipurile",
		allAccount: "Toate conturile",
		allCoin: "Toate monedele",
		coin: "Monedă",
		amount: "Sumă modificare",
		balance: "Sold după modificare",
		time: "Timp",
		title: "Înregistrări modificare cont",
		filtrar: "Filtrează",
		check: "Comută la",
		showOnly: "Afișează doar monede deținute",
		holdAssets: "Sold monede deținute",
		accountList: "Listă conturi"
    },
    contractTransaction: {
		chart: "Grafic",
		basicEdition: "Ediție de bază",
		depthMap: "Hartă de adâncime",
		second: "Secundă",
		minute: "Minut",
		day: "Zi",
		week: "Săptămână",
		month: "Lună",
		open: "Deschis",
		trade: "Tranzacție",
		buyLong: "Cumpărare poziție lungă",
		buyShort: "Cumpărare poziție scurtă",
		cannotBuy: "Această monedă nu suportă tranzacționarea contractelor cu livrare",
		cannotBuy1: "Această monedă nu suportă tranzacționarea perpetuă",
		tradingAssets: "Active tranzacționate",
		amountAvailable: "Cantitate disponibilă",
		timeStr: "Timp",
		transactionPeriod: "Perioada tranzacției",
		quantity: "Cantitate",
		enterQuantity: "Introduceți cantitatea",
		buyIn: "Cumpără poziție lungă",
		latestTransaction: "Ultima tranzacție",
		time: "Timp",
		direction: "Direcție",
		price: "Preț",
		sell: "Cumpără poziție scurtă",
		positionOrder: "Comandă livrare",
		historicalOrders: "Comenzi istorice",
		product: "Produs",
		realAccount: "(Cont real)",
		demoAccount: "(Cont simulare)",
		openingTime: "Timp comandă",
		openingPrice: "Preț de deschidere",
		curretPrice: "Preț curent",
		liquidationPrice: "Preț lichidare",
		profitOrLoss: "Profit/Pierdere",
		endTime: "Timp închidere",
		areYouSureToBuy: "Sigur doriți să cumpărați?",
		areYouSureToLongBuy: "Sigur doriți să cumpărați poziție lungă?",
		areYouSureToShortBuy: "Sigur doriți să cumpărați poziție scurtă?",
		successfullyBought: "Cumpărare reușită",
		minBuy: "Cumpărare minimă",
		assets: "Active",
		withdraw: "Retragere",
		entrustedOrder: "Comandă delegată",
		total: "Total",
		continueToPlaceOrder: "Continuă să plasezi comanda",
		orderConfirmation: "Confirmarea comenzii",
		buyRu: "Cumpără",
		sellChu: "Vinde",
		areYouSureToSell: "Sigur doriți să vindeți?",
		operation: "Operațiune",
		buyCover: "Acoperire poziție",
		commitSuccess: "Tranzacție reușită",
		onlyEnterIntegers: "Introduceți numai numere întregi",
		trend: "Tendință",
		lotteryTime: "Termen limită plasare comenzi",
		countdown: "Numărătoare inversă",
		period: "Numărul perioadei",
		cycle: "Perioada de timp",
		unlimited: "Nelimitat",
		put: "PUT",
		call: "CALL",
		pending: "În așteptare",
		unopened: "Neextras",
		opened: "Extras",
		settlementPrice: "Preț de decontare",
		rateOfReturn: "Randament",
		currentPositions: "Poziții curente",
		positionQuantity: "Cantitate poziție",
		guarantee: "Garanție",
		text1: "Creștere",
		text2: "Scădere",
		text3: "Așteptare cumpărare",
		text4: "Cantitate comandă",
		text5: "Cantitate tranzacționată",
		text6: "Anulează",
		text7: "Timp livrare",
		text8: "Avertizare anulare",
		text9: "Sigur doriți să anulați comanda?",
		text10: "Cantitate invalidă",
		text11: "Avertizare comandă",
		text12: "Sigur doriți să cumpărați call?",
		text13: "Sigur doriți să cumpărați put?",
		text14: "Anulare reușită"
    },
    mining: {
		title1: "Platforma de minerit de active digitale blockchain de top mondial",
		title2: "Transparentă și sigură · Stabilă",
		title3: "Vă rugăm să selectați moneda",
		title4: "Randament anualizat la minerit",
		title5: "Zile",
		title6: "Perioada de minerit",
		title7: "Detalii produs",
		btn: "Minează acum",
		btn2: "Închide",
		tabs1: "În curs",
		tabs2: "Răscumpărate",
		table1: "Numele produsului",
		table2: "Perioada de minerit",
		table3: "Timpul de minerit",
		table4: "Suma minată",
		table5: "Data scadenței",
		table6: "Venitul la scadență",
		table7: "Starea comenzii",
		egularMining: "Minerit regulat",
		inProgress: "În curs",
		redeemed: "Răscumpărat",
		redemption: "Răscumpărare",
		regularMining: "Minerit regulat",
		earlyRedemption: "Răscumpărare anticipată",
		need: "Necesită",
		handlingFee: "Taxă de procesare",
		redemptionConfirmationMessage: "Vă rugăm să confirmați dacă doriți răscumpărarea anticipată?",
		form1: "Randament anualizat la minerit",
		form2: "Perioada de minerit",
		form3: "Moneda de minerit",
		form4: "Suma de subscriere (minimă/maximă)",
		form5: "Taxă de răscumpărare anticipată: ",
		form6: "Suma de cumpărare",
		form7: "Fonduri disponibile",
		form8: "Suma de cumpărare",
		form9: "Fonduri disponibile",
		form10: "Vă rugăm să introduceți suma de cumpărare",
		form11: "Tot",
		form12: "Venit estimat",
		form13: "Fonduri insuficiente",
		form14: "Vă rugăm să introduceți suma de cumpărare",
		form15: "Comenzile mele",
		form16: "Venit",
		form17: "Detalii comandă",
		form18: "Notificare răscumpărare anticipată:",
		form19: "Suma de subscriere (minimă)",
		form20: "Suma de subscriere (maximă)",
		form21: "Cantitate deținută",
		form22: "Timpul cumpărării",
		form23: "Timpul răscumpărării",
		form24: "Încheiat",
		form25: "Subscriere reușită",
		form26: "Răscumpărare reușită",
		form27: "Gestionați cu ușurință finanțele cu peste 25% profit, depășiți piața și primiți recompense după cumpărare",
		form28: "Invită prieteni și câștigă 50 USDT, plus cupoane de contract și 20% comision returnat"
    },
    assets: {
		content1: "Active cont",
		content2: "Câștiguri de azi",
		content3: "Cont curent",
		content4: "Contul real reprezintă activele contului dvs. real, utilizabile pentru tranzacții și retrageri",
		content5: "Retragere",
		content6: "Depunere",
		content7: "Schimb valutar",
		content8: "Transfer",
		content9: "Vă rugăm să selectați",
		content10: "Cont demo",
		content11: "Cont real",
		content12: "Obține active",
		content13: "Sunteți sigur că doriți să comutați la contul real?",
		content14: "Sunteți sigur că doriți să comutați la contul demo?",
		content15: "Obținere reușită",
		table1: "Monedă",
		table2: "Cantitate",
		table3: "Înghețat",
		table4: "Disponibil",
		dialog1: "Detalii produs",
		dialog2: "1. Acest activ poate fi utilizat doar în modul cont demo",
		dialog3: "2. Pentru a preveni abuzul, poate fi primit o singură dată pe lună",
		dialog4: "3. Obținerea activelor va adăuga suma activelor primite fără a modifica poziția deținuta",
		dialog5: "4. Dacă aveți alte întrebări, vă rugăm să contactați serviciul clienți",
		dialog6: "Închide",
		dialog7: "Obține acum active demo",
		dialog8: "Transferă în",
		dialog9: "Transferă din",
		dialog10: "Comută",
		dialog11: "Evaluare",
		dialog12: "Active demo",
		dialog13: "Contul meu",
		dialog14: "Active totale cont",
		dialog15: "Prezentare active",
		dialog16: "Evaluare totală active",
		dialog17: "Evaluare active",
		dialog18: "Câștiguri de azi",
		dialog19: "Fonduri înghețate",
		dialog20: "Limita lunară de active demo pe care o puteți obține",
		dialog21: "Primește",
		dialog22: "Ați primit cu succes",
		dialog23: "Câștiguri cumulate în 30 de zile",
		dialog24: "Produse financiare",
		dialog25: "Finanțarea mea",
		dialog26: "Finanțări istorice",
		dialog27: "Istoric",
		dialog28: "Istoric fonduri"
    },
    validator: {
		dialog14: "Validator",
		dialog15: "Leagă validatorul",
		dialog16: "Comutator validator",
		dialog17: "Cod de verificare",
		dialog18: "Cod QR al validatorului",
		dialog19: "Cheia validatorului",
		dialog20: "Salvează",
		dialog21: "Vă rugăm să selectați un validator",
		dialog22: "Copiază cheia",
		dialog23: "Salvare reușită",
		dialog24: "Vă rugăm să introduceți codul de verificare",
		dialog25: "Sfat prietenos: înainte de a confirma salvarea, vă rugăm să deschideți aplicația corespunzătoare pentru a scana codul QR de mai jos sau să adăugați cheia manual!",
		dialog26: "Porniți validatorul pentru a oferi cea mai bună protecție contului dvs.",
		dialog27: "Veți avea nevoie să introduceți un cod unic generat prin telefon de fiecare dată când vă conectați sau faceți retrageri.",
		dialog28: "Setați validatorul",
		dialog29: "Ajutor",
		dialog30: "Nu ați legat încă codul de autentificare. Folosiți un validator pentru o protecție mai puternică.",
		dialog31: "Validatorul nu este setat încă, vă rugăm să îl configurați mai întâi",
		dialog32: "Configurare"
    },
    recharge: {
		title1: "Nu știi cum să folosești criptomonede pentru a cumpăra?",
		title2: "Doar trei pași simpli!",
		title3: "Selectează criptomoneda pe care dorești să o cumperi din meniul derulant, apoi introdu cantitatea sau suma de cumpărat.",
		title4: "Alege metoda de plată preferată",
		title5: "După confirmarea plății, criptomoneda cumpărată va fi transferată automat în contul tău.",
		title6: "Te rugăm să selectezi moneda pe care dorești să o încarci",
		title7: "Înregistrări încărcare fonduri",
		table1: "Monedă",
		table2: "Cantitate",
		table3: "Numele rețelei",
		table4: "Stare",
		table5: "Motiv",
		table6: "Timp",
		table7: "Vezi dovada",
		dialog1: "Te rugăm să introduci codul de verificare de mai jos",
		dialog2: "Cod de plată",
		dialog3: "Copiază",
		dialog4: "Adresă",
		dialog5: "Cantitate încărcată",
		dialog6: "Captură tranzacție",
		dialog7: "Notificare importantă",
		dialog8: "Te rugăm să introduci cantitatea de încărcare",
		dialog9: "Încarcă imagine",
		dialog10: "Te rugăm să introduci conținut",
		dialog11: "Te rugăm să încarci captura de ecran a încărcării",
		dialog12: "Neaprobat",
		dialog13: "Respins",
		dialog14: "Fonduri primite",
		tip1: "Trimitere reușită",
		tip2: "Copiere reușită",
		tip3: "Copiere eșuată",
		tip4: "Te rugăm să selectezi moneda pentru încărcare",
		tip5: "1. Adresa de încărcare de mai sus este adresa oficială a platformei; te rugăm să o verifici cu atenție, pierderile cauzate de încărcări greșite vor fi suportate de utilizator;",
		tip6: "2. Asigură-te că computerul și browserul sunt securizate pentru a preveni modificarea sau scurgerea informațiilor;",
		tip7: "3. După ce ai făcut încărcarea la adresa de mai sus, aceasta va fi confirmată de întreaga rețea înainte de a apărea în cont;",
		tip8: "4. Pentru sistemul de token-uri și monede de mai sus, te rugăm să transferi suma corectă pentru încărcare; nu trimite alte active neasociate, deoarece nu vor putea fi recuperate.",
		tip9: "Salvează codul QR",
		tip10: "Încarcă fonduri",
		tip11: "Notificare importantă",
		tip12: "Link OTC",
		tip13: "Cod QR pentru încărcare",
		tip14: "Pasul următor",
		tip15: "Înregistrări încărcare",
		tip16: "Detalii încărcare",
		tip17: "Adresă încărcare",
		tip18: "Plată rapidă",
		tip20: "Sold insuficient",
		tip22: "Trimis, așteaptă confirmarea",
		tip23: "Așteptare plată",
		tip24: "Sumă",
		tip25: "Plata trimisă, așteaptă confirmarea blockchain",
		tip26: "Plata a fost refuzată",
		tip27: "Plata a eșuat",
		tip28: "Plata a reușit",
		bankChannel: "Canal card bancar",
		tip29: "Căutări istorice",
		tip30: "Listă monede",
		tip31: "Selectează rețeaua",
		tip32: "Când încarci această monedă, te rugăm să folosești doar rețelele acceptate de mai jos; încărcările prin alte rețele pot duce la pierderea fondurilor.",
		tip33: "Când retragi această monedă, te rugăm să folosești doar rețelele acceptate de mai jos; retragerile prin alte rețele pot duce la pierderea fondurilor.",
		tip34: "Încărcare rapidă",
		tip35: "Încărcare scanând codul QR",
		tip36: "Încărcare manuală",
		tip37: "Rețea pentru încărcare",

		tip38: "Adresă încărcare",
		tip39: "Sumă încărcare",
		tip40: "Încărcare dovadă tranzacție",
		tip41: "Încarcă imagine",
		tip42: "Confirmă trimiterea",
		tip43: "Confirmă plata",
		tip44: "Notă: Te rugăm să confirmi adresa de încărcare; în caz de greșeală și pierdere a fondurilor, nu ne asumăm responsabilitatea.",
		tip45: "Atenționare",
		tip46: "Adresă copiată cu succes!",
		tip47: "Copiere adresă eșuată!",
		tip48: "Sold insuficient disponibil",
		tip49: "Încărcare trimisă cu succes, așteaptă confirmarea pe blockchain",
		tip50: "Încărcare eșuată",
		tip51: "Sumă încărcare incorectă",
		tip52: "Conexiune eșuată",
		tip53: "Portofel neautentificat",
		tip54: "Conexiune refuzată",
		tip55: "Trimitere reușită, așteaptă aprobarea serviciului clienți",
		tip56: "Te rugăm să încarci captura dovadă a tranzacției",
		tip57: "Trimitere eșuată",
		tip58: "Înregistrări încărcare",
		tip59: "Înregistrări retragere",
		tip60: "Monedă încărcată",
		tip61: "Monedă retrasă",
		tip62: "Adresă încărcare",
		tip63: "Captură afișată",
		tip64: "Click pentru a mări imaginea",
		tip65: "Data încărcării",
		tip66: "Motiv respingere",
		tip67: "Sumă retragere",
		tip68: "Sumă primită",
		tip69: "Rețea retragere",
		tip70: "Adresă retragere",
		tip71: "Data retragerii",
		tip72: "Închide",
		tip73: "Captură tranzacție",
		tip74: "Audit",
		tip75: "Respins",
		tip76: "Finalizat",
		tip77: "Respins",
		tip78: "Verificat",
		tip79: "Plată efectuată",
		tip80: "Retragere",
		tip81: "Rețea transfer",
		tip82: "Adresă/Bilet",
		tip83: "Retragere totală",
		tip84: "Vă rugăm să nu retrageți direct către adrese de crowdfunding sau ICO, altfel nu veți primi token-urile emise de crowdfunding sau ICO.",
		tip85: "Sumă primită",
		tip86: "Confirmă retragerea",
		tip87: "Adresă retragere incorectă",
		tip88: "Sumă retragere incorectă",
		tip89: "Suma minimă de retragere este",
		tip90: "Suma maximă de retragere este",
		tip91: "Cererea de retragere a fost trimisă",
		tip92: "Listă adrese",
		tip93: "Nu ați adăugat încă nicio adresă",
		tip94: "Adaugă acum",
		tip95: "Adaugă adresă",
		tip96: "Adaugă adresă nouă",
		tip97: "Vă rugăm să selectați",
		tip98: "Adresă",
		tip99: "Vă rugăm să selectați rețeaua de transfer",
		tip100: "Vă rugăm să introduceți adresa",
		tip101: "Adresă adăugată cu succes",
		tip102: "În tranzacție",
    },
    fundExchange: {
		title1: "Cum să schimbați fonduri?",
		title2: "Selectați moneda corespunzătoare pe care doriți să o schimbați.",
		title3: "Selectați moneda corespunzătoare pentru schimb.",
		title4: "Introduceți cantitatea de schimb și apoi faceți clic pe trimite pentru a finaliza schimbul de fonduri.",
		title5: "De la",
		title6: "La",
		title7: "Cantitatea de schimb",
		title8: "Rată de schimb",
		title9: "Disponibil",
		title10: "Vă rugăm să introduceți cantitatea de schimb",
		title11: "Nu există un trading pair corespunzător pentru schimb",
		title12: "Vă rugăm să introduceți cantitatea de schimb dorită",
		title13: "Schimb realizat cu succes",
		title14: "Istoric schimburi",
		table1: "Monedă utilizată",
		table2: "Cantitate",
		table3: "Rată de schimb",
		table4: "Monedă schimbată",
		table5: "Sumă primită",
		table6: "Timp",
		title15: "De la",
		title16: "În prezent nu există active disponibile, vă rugăm să selectați altceva"
    },
    fundTransfer: {
		title1: "Cum să transferați fonduri?",
		title2: "Selectați contul curent de la care doriți să transferați.",
		title3: "Selectați contul către care doriți să transferați.",
		title4: "Introduceți suma de transfer, faceți clic pe trimite și finalizați transferul.",
		title5: "Monedă",
		title6: "Cantitate transferată",
		title7: "Vă rugăm să introduceți cantitatea de transferat",
		title8: "Istoric transferuri",
		title9: "Vă rugăm să selectați tipul portofelului",
		title10: "Vă rugăm să selectați moneda",
		title11: "Vă rugăm să selectați tipul portofelului",
		title12: "Vă rugăm să selectați moneda",
		title13: "Vă rugăm să introduceți cantitatea de transferat",
		title14: "Trimitere reușită",
		table1: "Cont de unde se transferă",
		table2: "Moneda transferată",
		table3: "Cantitate transferată",
		table4: "Cont de destinație",
		table5: "Timp",
		table6: "Transfer",
		table7: "Transfer de fonduri",
		table8: "Transfer către",
		table9: "Istoric transferuri",
		table10: "Detalii transfer",
		table11: "Transfer reușit",
		table12: "Transfer eșuat",
		table13: "Contul curent nu poate fi transferat"
    },
    withdrawal: {
		title1: "Notificare importantă",
		title2: "1. Pentru a preveni activitățile de spălare de bani, puteți solicita retragerea după ce volumul tranzacțiilor atinge limita.",
		title3: "2. După ce solicitați retragerea, fondurile vor ajunge în termen de 24 de ore; dacă nu ați primit fondurile după timpul estimat, vă rugăm să contactați serviciul clienți online.",
		title4: "3. După ce ați trimis cererea de retragere, fondurile sunt blocate deoarece retragerea este în proces; acestea sunt gestionate temporar de sistem și nu înseamnă că ați pierdut fondurile sau că acestea au fost compromise.",
		title5: "Monedă",
		title6: "Adresa portofelului",
		title7: "Sumă de retras",
		title8: "Istoric retrageri",
		title9: "Vă rugăm să selectați moneda",
		title10: "Vă rugăm să selectați tipul lanțului",
		title101: "",
		title11: "Vă rugăm să introduceți",
		title12: "Adresa portofelului",
		title13: "Trimitere reușită",
		title14: "În curs de verificare",
		title15: "Verificare reușită",
		title16: "Verificare eșuată",
		title17: "Fonduri retrase",
		title18: "Vă rugăm să introduceți sau să lipiți adresa portofelului",
		title19: "Vă rugăm să introduceți suma de retras",
		title20: "Taxe",
		title21: "Sumă efectivă primită",
		table1: "Monedă",
		table2: "Sumă retrasă",
		table3: "Numele lanțului",
		table4: "Adresa portofelului",
		table5: "Stare",
		table6: "Motiv",
		table7: "Data cererii",
		table8: "Retragere",
		table81: "Retragere",
		table9: "Adresa retragerii",
		table10: "Vă rugăm să selectați moneda pentru retragere",
		table11: "Vă rugăm să vă asigurați că introduceți",
		table12: "adresa (de obicei începe cu „0x”)",
		table13: "Sumă disponibilă pentru retragere (după deducerea taxelor):",
		table14: "Selectați moneda",
		table15: "Probleme? Raportați acum",
		table16: "Sold",
		table17: "Detalii retragere",
		password: "Parolă",
		passwordTips: "Vă rugăm să introduceți parola",
		passwordAg: "Confirmare parolă",
		passwordAgTips: "Vă rugăm să introduceți parola din nou",
		oldPassword: "Parolă veche",
		oldPasswordTips: "Vă rugăm să introduceți parola veche",
		newPassword: "Parolă nouă",
		newPasswordTips: "Vă rugăm să introduceți parola nouă",
		passwordNotSame: "Parolele nu coincid",
		withdrawPasswordSet: "Setați parola de retragere",
		withdrawPasswordModify: "Modificați parola de retragere",
		withdrawPassword: "Parolă de retragere",
		withdrawPasswordTips: "Vă rugăm să introduceți parola de retragere",
		setWithdrawPasswordFirst: "Vă rugăm să setați mai întâi parola de retragere",
		withdrawPasswordSetSuccess: "Setare reușită",
		withdrawPasswordModifySuccess: "Modificare reușită",
		submit: "Trimite",
    },
    customer: {
		content1: "Serviciu clienți online",
		content2: "Asistență clienți",
		content3: "Vă rugăm să introduceți datele dvs. de contact",
		content4: "Vă rugăm să introduceți conținutul",
		content5: "Trimite",
		content6: "Trimiterea a eșuat, conexiune la rețea eșuată",
		content7: "Imagine",
		content8: "Mesajul este gol",
		content9: "Partajările mele",
		content10: "Link de partajare",
		content11: "Salvează imaginea",
		content12: "Veniturile mele",
		content13: "Descrierea nivelului",
		content14: "Număr de membri în echipă",
		content15: "Venituri din invitații",
		content16: "Descrierea regulilor",
		content17: "Nivel membru",
		content18: "Suma depunerii mai mare decât",
		content19: "Nivel echipă",
		content20: "Nivel și venituri echipă",
		content21: "Îndeplinește condițiile",
		content22: "Venituri din distribuție",
		content23: "Nivel echipă",
		content24: "Nivel, a invitat",
		content25: "membri valizi",
		content26: "Venituri nivel 1",
		content27: "Venituri nivel 2",
		content28: "Venituri nivel 3",
    },
    standardContract: {
		increaseMargin: "Crește marja",
		increaseAmount: "Crește suma",
		Pleaseenterthemargin: "Vă rugăm să introduceți suma marjei de crescut",
		Pleaseenterthecorrect: "Vă rugăm să introduceți o sumă corectă a marjei",
		Increasemarginsuccessfully: "Marja a fost crescută cu succes",
		takeProfitPriceWrong: "Prețul pentru profitul țintă este incorect",
		stoppriceerror: "Prețul stop-loss este incorect",
		thetakeprofit1: "Prețul pentru profitul țintă trebuie să fie mai mare decât prețul pieței",
		thetakeprofit2: "Prețul stop-loss trebuie să fie mai mic decât prețul pieței",
		thetakeprofit3: "Prețul pentru profitul țintă trebuie să fie mai mic decât prețul pieței",
		thetakeprofit4: "Prețul stop-loss trebuie să fie mai mare decât prețul pieței",
		thetakeprofit5: "Cantitate incorectă",
		estimatedprofitloss: "Profit/Pierdere estimată",
		positionAmount: "Cantitatea poziției",
		closeAmount: "Cantitate de închidere",
		whenthelatest: "Când prețul cel mai recent atinge",
		whenthelatest2: ", se va declanșa un ordin de închidere a poziției curente la prețul pieței pentru profit țintă. Profit/Pierdere estimată",
		whenthelatest3: ", se va declanșa un ordin de închidere a poziției curente la prețul pieței pentru stop loss. Profit/Pierdere estimată",
		contract: "Contract",
		ordercanceledsuccessfully: "Comanda a fost anulată cu succes",
		successfullyordered: "Comandă plasată cu succes",
		positionopeningreminder: "Reamintire deschidere poziție",
		wrongquantity: "Cantitate incorectă",
		quantitycannot: "Cantitatea nu poate fi mai mare decât",
		modificationstoploss: "Modificarea profitului țintă și stop-loss realizată cu succes",
		positionclosedsuccessfully: "Poziția a fost închisă cu succes",
		orderCancellation: "Anulare comandă",
		orderCancellation2: "Sigur doriți să anulați comanda?",
		tobeexecuted: "De executat",
		expired: "Expirată",
		failed: "Eșuată",
		contractTransaction: "Contract perpetuu",
		increase: "Creștere",
		openPosition: "Poziție globală",
		isolatedPosition: "Poziție izolată",
		limitOrder: "Limită",
		marketOrder: "Piață",
		pleaseSelectLeverage: "Vă rugăm să selectați efectul de levier",
		pleaseEnterQuantity: "Vă rugăm să introduceți cantitatea",
		canOpenMore: "Cantitate maximă deschidere poziție",
		contractAmount: "Suma contractului",
		openingFee: "Comision",
		currentPosition: "Poziție curentă",
		historicalPositions: "Tranzacții istorice",
		currentCommission: "Comandă curentă",
		historicalCommission: "Comandă istorică",
		buyPrice: "Preț cumpărare",
		income: "Profit",
		quantity: "Cantitate",
		marginRate: "Rată marjă",
		initialMargin: "Marjă inițială",
		estimatedPriceParity: "Preț de lichidare forțată",
		operate: "Acțiune",
		finishQuantity: "Cantitate tranzacționată",
		averagePrice: "Preț mediu tranzacționat",
		pleaseEnterLeverage: "Vă rugăm să introduceți efectul de levier",
		takeProfitAndStopLoss: "Profit țintă și stop loss",
		takeProfit: "TP",
		stopLoss: "SL",
		openLong: "LONG",
		openShort: "SHORT",
		liquidation: "Închidere poziție",
		marketLquidation: "Închidere completă la preț de piață",
		cancel: "Anulează comandă",
		enterBuyPrice: "Vă rugăm să introduceți prețul de cumpărare",
		areYouSureLquidation: "Sigur doriți să închideți poziția?",
		confirm: "Confirmă",
		enterStopWinPrice: "Vă rugăm să introduceți prețul de profit țintă",
		enterStopLossPrice: "Vă rugăm să introduceți prețul stop loss",
		commissionTime: "Timp comandă",
		commissionPrice: "Preț comandă",
		commissionQuantity: "Cantitate comandată",
		volumeAlreadyTraded: "Cantitate tranzacționată",
		areYouSureToWinOrLoss: "Sigur doriți să setați profit țintă și stop loss?",
		maxQuantity: "Cantitate maximă deținută",
		saleQuantity: "Cantitate închisă",
		salePrice: "Preț mediu închidere",
		saleTime: "Timp",
		succeeded: "Finalizat",
		cancelled: "Anulat",
		piece: "contracte",
		triggerPrice: "Preț declanșator",
		setWin: "Setează profit țintă",
		setLoss: "Setează stop loss",
		enterWinQuantity: "Vă rugăm să introduceți cantitatea pentru profit țintă",
		enterLossQuantity: "Vă rugăm să introduceți cantitatea pentru stop loss",
		planCommission: "Ordin planificat",
		enterWinTriggerPrice: "Vă rugăm să introduceți prețul declanșator pentru profit țintă",
		enterLossTriggerPrice: "Vă rugăm să introduceți prețul declanșator pentru stop loss",
		insufficientQuantity: "Cantitate insuficientă",
		enterTriggerPrice: "Vă rugăm să introduceți prețul declanșator",
		tips1: "Prețul comenzii dumneavoastră este mai mare decât prețul curent, comanda se va executa la prețul pieței. Sigur doriți să cumpărați?",
		tips2: "Prețul comenzii dumneavoastră este mai mic decât prețul curent, comanda se va executa la prețul pieței. Sigur doriți să cumpărați?",
		type: "Tip",
		increaseQuantity: "Crește poziția",
		reduceQuantity: "Reduce poziția",
		limitCommission: "Ordin limită",
		tips3: "Prețul stop loss trebuie să fie mai mic decât prețul pieței",
		tips4: "Prețul take profit trebuie să fie mai mare decât prețul pieței",
		tips5: "Prețul stop loss trebuie să fie mai mare decât prețul pieței",
		tips6: "Prețul take profit trebuie să fie mai mic decât prețul pieței",
		tips7: "Prețul stop loss trebuie să fie mai mic decât prețul pieței și mai mic decât prețul comenzii",
		tips8: "Prețul take profit trebuie să fie mai mare decât prețul comenzii (poate fi mai mic decât prețul pieței)",
		tips9: "Prețul stop loss trebuie să fie mai mare decât prețul pieței și mai mare decât prețul comenzii",
		tips10: "Prețul take profit trebuie să fie mai mic decât prețul comenzii (poate fi mai mare decât prețul pieței)",
		accountEquity: "Sold cont",
		unrealizedPL: "Profit/Pierdere nerealizată",
		tips11: "Sunteți sigur că doriți pentru",
		tips12: "să executați la prețul pieței",
		tips13: "închidere completă a poziției",
		tips14: "Nu mai afișa acest mesaj",
		profitRate: "Randament închidere poziție",
		openTime: "Timp deschidere poziție",
		unwindTime: "Timp închidere poziție",
		dealTime: "Timp tranzacție",
		amountClose: "Sumă închisă",
		long: "Long",
		short: "Short",
		orderQuantity: "Cantitate comandată",
		entrustedMargin: "Marjă alocată",
    },
    spotGoods: {
		spotGoods: "Schimb rapid",
		sellPrice: "Preț de vânzare",
		orderRecord: "Istoric schimb rapid",
		transactionTime: "Timp tranzacție",
		maxBuy: "Maxim de cumpărat",
		maxSell: "Maxim de vândut",
		purchaseQuantity: "Cantitate cumpărată",
		slippage: "Derivație",
		convertTips: "Vom executa la cel mai bun preț, cu derivație între 0-5%.",
		changePrice: "Preț curent de schimb",
		consume: "Consum",
		consumeAmount: "Cantitate consumată",
		get: "Obține",
		getAmount: "Cantitate obținută",
		changeTips: "Sigur doriți să faceți schimbul?",
		confirm: "Confirmă schimbul"
    },
    news: {
		title: "Centrul de Știri",
		redMore: "Citește mai mult",
    },
    credit: {
		credit: "Puncte de credit",
		creditScore: "Scor total de credit",
		latestEntry: "Ultima înregistrare",
		liveUpdate: "Actualizare în timp real",
		systemEvaluation: "Evaluare sistem",
		time: "Data",
		name: "Nume",
		reason: "Motiv",
		scoreStory: "Istoricul punctelor de credit"
    },
    borrowing: {
		borrowing: "Împrumut",
		diversifiedMarket: "Piață diversificată",
		totalSupply: "Total ofertat",
		totalBorrowings: "Total împrumutat",
		tips1: "Aceasta este suma totală pe care o puteți împrumuta, în funcție de garanțiile dvs., până la limita maximă de împrumut.",
		tips2: "Pe durata împrumutului, rata fixă va rămâne neschimbată. Recomandată pentru furnizori pe termen lung și pentru cei care preferă predictibilitatea.",
		totalSupplys: "Total ofertat",
		supplyAPR: "Rata dobânzii pentru ofertare",
		totalBorrowings: "Total împrumutat",
		borrowAPR: "Rata dobânzii pentru împrumut",
		check: "Vezi",
		market: "Piață",
		availableLiquidity: "Lichiditate disponibilă",
		currencyPrice: "Preț curent al monedei",
		supplyAssets: "Active ofertate",
		tips3: "Notă: Rata de mai jos este fixă, iar la finalul perioadei de ofertare, principalul plus câștigul vor fi returnate în contul dvs.",
		supplyCycle: "Perioadă ofertare",
		minimumSupply: "Ofertă minimă",
		supply: "Oferă",
		borrowedAssets: "Active împrumutate",
		tips4: "Notă: Pentru a împrumuta, trebuie să oferiți orice garanție sau dovadă,",
		tips5: "Consultați instrucțiunile privind garanțiile.",
		repaymentCycle: "Perioadă rambursare",
		BorrowableAmount: "Limită de împrumut disponibilă",
		borrow: "Împrumut",
		accountInformation: "Informații cont",
		walletBalance: "Sold portofel",
		canSupply: "Poate oferi",
		AmountCanBeBorrowed: "Limită totală de împrumut disponibilă",
		borrowedAmount: "Sumă împrumutată",
		remainingAmount: "Limită rămasă",
		getBorrowednAmount: "Obține limită împrumut",
		supplyOrder: "Comandă ofertare",
		borrowedOrder: "Comandă împrumut",
		supplyAmount: "Sumă ofertată",
		expectedProfits: "Profit estimat",
		supplyTime: "Timp ofertare",
		expirationTime: "Data expirării",
		borrowingAmount: "Sumă împrumutată",
		dueRepayment: "Sumă rambursabilă",
		borrowingTime: "Timp acordare împrumut",
		repaymentTime: "Timp rambursare",
		repay: "Rambursează",
		supplyCurrency: "Monedă de furnizare",
		buyNow: "Cumpără acum",
		supplyRecords: "Înregistrări de furnizare",
		borrowRecords: "Înregistrări de împrumut",
		completed: "Finalizat",
		borrowNow: "Împrumută acum",
		borrowCurrency: "Monedă de împrumut",
		borrowMin: "Minim",
		borrowMax: "Maxim",
		borrowRange: "Suma împrumutului (minim/maxim)",
		tips6: "Vă rugăm să rambursați la timp, în caz de întârziere, se va percepe zilnic o taxă suplimentară din suma (principal + dobândă)",
		tips7: "ca taxă de întârziere.",
		pleaseEnterBorrowAmount: "Vă rugăm să introduceți suma împrumutului",
		interest: "Dobândă",
		tips8: "Sunteți sigur că doriți să rambursați anticipat?",
		borrowChannel: "Canal de împrumut",
		tips9: "Să începem prin a te cunoaște",
		name: "Prenume",
		lastName: "Nume",
		birthDate: "Data nașterii",
		tips10: "Mai multe informații, care este adresa ta?",
		familyAddress: "Adresa de domiciliu (inclusiv numărul unității)",
		city: "Oraș",
		country: "Țară",
		postalCode: "Cod poștal",
		pleaseEnterYourHomeAddress: "Vă rugăm să introduceți adresa de domiciliu",
		tips11: "Spune-ne situația ta financiară",
		tips12: "Este posibil să avem nevoie să confirmăm aceste informații mai târziu, așa că vă rugăm să fiți cât mai precis",
		yourMonthlyIncome: "Venitul lunar",
		enterYourMonthlyIncome: "Introduceți venitul lunar",
		extraIncomeOptional: "Venit suplimentar (opțional)",
		enterExtraIncome: "Introduceți venitul suplimentar",
		monthlyRentOrMortgagePayment: "Chirie lunară sau plată ipotecară",
		enterMonthlyRent: "Introduceți chiria sau plata lunară la ipotecă",
		tip13: "Spune-ne dacă ai ipotecă",
		tip14: "Dacă nu selectați garanția ipotecară, probabilitatea de aprobare este mai mică",
		isThereMortgage: "Există ipotecă?",
		selectIsThereMortgage: "Vă rugăm să selectați dacă aveți ipotecă",
		selectMortgageType: "Vă rugăm să selectați tipul ipotecii",
		yes: "Da",
		no: "Nu",
		uploadScreenshotOfTransaction: "Vă rugăm să încărcați captura de ecran a tranzacției",
		tip15: "Să păstrăm legătura",
		tip16: "Dacă avem nevoie de mai multe informații despre cererea dvs. de împrumut, este posibil să vă contactăm prin acest număr",
		tip17: "Am citit și sunt de acord prin semnătură electronică",
		tip18: "Termenii de utilizare și acordul electronic",
		tip19: ", inclusiv acceptarea de a vă trimite informații despre",
		tip20: "Termenii de utilizare ai produselor și serviciilor noastre",
		tip21: "După completarea datelor, vă rugăm să așteptați evaluarea sistemului.",
		phoneNumber: "Număr de telefon",
		enterPhoneNumber: "Vă rugăm să introduceți numărul dvs. de telefon",
		tip22: "Vă rugăm să bifați că sunteți de acord cu termenii de utilizare și acordul electronic",
		inReview: "În curs de evaluare",
		applicationAmount: "Sumă solicitată",
		reasonForRejection: "Motivul respingerii",
		reapply: "Aplică din nou",
		applyStatus: "Starea cererii",
		currentOrder: "Comanda curentă",
		interestRate: "Rată a dobânzii"
    },
    yuebao: {
		filed1: "Depus",
		filed2: "Retras",
		filed3: "Profit zilnic",
		filed4: "Accelerare echipă",
		filed5: "Depus deja",
		filed6: "Profit ieri",
		filed7: "Profit total",
		filed8: "Fonduri disponibile",
		filed9: "Vă rugăm să introduceți suma",
		filed10: "Minerit de lichiditate",
		filed11: "Introducere",
		field12: "Minim cumpărat",
		field13: "Maxim cumpărat",
		filed14: "Subscriere",
		filed15: "Periodic",
		filed16: "Rată anuală",
    },
    tipsPopover: {
		title: "Instalați această aplicație",
		press: "Apăsați",
		and: "și",
		scrren: "Adăugați pe ecranul principal",
		hasInstall: "(Dacă este deja instalat, vă rugăm să închideți această fereastră)",
    },
    follow: {
		title1: "Plan de urmărire",
		follow_text1: "Inițiază urmărirea",
		follow_text2: "Istoric publicări",
		follow_text3: "Titlu",
		follow_text4: "Pereche de tranzacționare",
		follow_text5: "Durata cumpărării",
		follow_text6: "Timpul plasării comenzii",
		follow_text7: "Timpul publicării",
		follow_text8: "Număr de urmăritori",
		follow_text9: "Suma urmărită",
		follow_text10: "Acțiune",
		follow_text11: "Invită",
		follow_text12: "Direcția urmăririi",
		follow_text13: "Setează condițiile de urmărire",
		follow_text14: "Limitări ale condițiilor de urmărire",
		follow_text15: "Sumă fixă",
		follow_text16: "Procentaj",
		follow_text17: "Invitat",
		follow_text18: "ID-ul persoanei",
		follow_text19: "Confirmă urmărirea",
		follow_text20: "Suma dvs. de urmărire (opțional)",
		follow_text21: "Vă rugăm să introduceți titlul",
		follow_text22: "Vă rugăm să selectați perechea de tranzacționare",
		follow_text23: "Vă rugăm să selectați direcția urmăririi",
		follow_text24: "Vă rugăm să selectați durata cumpărării",
		follow_text25: "Vă rugăm să selectați timpul plasării comenzii",
		follow_text26: "Vă rugăm să selectați cantitatea de cumpărare",
		follow_text27: "Cantitatea maximă de cumpărare nu poate fi mai mică decât cea minimă",
		follow_text28: "Cumpărare minimă",
		follow_text29: "Cumpărare maximă",
		follow_text30: "Urmărire creată cu succes",
		follow_text31: "Lista perechilor de tranzacționare",
		follow_text32: "Urmărit",
		follow_text33: "Vă rugăm să introduceți informațiile invitatului",
		follow_text34: "Invitat",
		follow_text35: "Invitat de mine",
		follow_text36: "Istoricul urmăririi",
		follow_text37: "Intervalul sumei de urmărire",
		follow_text38: "Vă rugăm să introduceți codul de urmărire",
    },
    followHistory: {
		title1: "Istoric publicare",
		title2: "Istoric urmărire",
		follow_h_text1: "Suma totală urmărită",
		follow_h_text2: "Numărul total de urmăritori",
		follow_h_text3: "Număr de publicări",
		follow_h_text4: "Rata de câștig",
		follow_h_text5: "Număr de urmăriri",
		follow_h_text6: "Profit urmărire",
		follow_h_text7: "Direcție",
		follow_h_text8: "Câștig",
		follow_h_text9: "Pierdere",
    },
	"asset.index.1579E8B41F8D5134": "Activele mele",
	"asset.index.B3F6F05Dfbe431Cd": "Cont simulare",
	"asset.index.B9Aeab4Ee8F33746": "Evaluarea activelor",
	"asset.index.583Df8Bd541Eb7E8": "Tendința câștigurilor",
	"asset.index.B1254815D133Cc26": "7 zile",
	"asset.index.2F615F6C029F01B7": "30 zile",
	"asset.index.29439Fb58E4Bbe22": "Retragere",
	"asset.index.831Ab31568A78285": "Depunere",
	"asset.index.39F7A0D48D12E8C9": "Transfer",
	"asset.index.B99063C5689Beaec": "Schimb rapid",
	"asset.index.E1Dc620F2F038B2A": "Primește active",
	"asset.index.972A0B4C2B4393D0": "Contul meu",
	"asset.index.9Dfb0Fb334620733": "Sold disponibil",
	"asset.index.Cdc5Fbd26790Cb47": "Suma blocată",
	"asset.index.3D8132D72Ae965Cd": "Evaluare",
	"asset.receive.825503Cc430559Cb": "Active obținute",
	"asset.receive.54154A0553A535B7": "Active demonstrative",
	"asset.receive.F2E57B00A9C5D129": "1. Aceste active pot fi utilizate doar în modul cont simulare",
	"asset.receive.Ea0D1D52989299Bd": "2. Pentru a preveni abuzul, poate fi solicitată o singură dată pe lună",
	"asset.receive.090E0037Aa235D3D": "3. Activele primite se vor adăuga la suma existentă, fără a modifica poziția deținută",
	"asset.receive.7Fd4E1Abc805C0A6": "4. Pentru alte întrebări, vă rugăm să contactați suportul clienți",
	"asset.receive.Df5B3A511D986575": "Primește acum active demonstrative",
	"asset.records.1Fa02E8187A39592": "Ultimele trei luni",
	"asset.records.7B291C37333Fe34D": "De la cele mai recente",
	"asset.records.A476Cd1Ec868Fc5F": "Ultimele trei luni,",
	"asset.records.9D5755A842E55Bb7": "De la cele mai recente,",
	"asset.records.E3Fa05E607203Cdc": "Depunere",
	"asset.records.B4F206C6Bec08Dea": "Retragere",
	"asset.index.Df5B3A511D986576": "Ați primit cu succes active demonstrative",
	"deposit.depositSpeedy.Efe81D0E0174239B": "Metodă de plată",
	"deposit.depositSpeedy.B9293Ee96E435F85": "Monedă fiat",
	"deposit.depositSpeedy.16658A855F07D171": "Sumă",
	"deposit.depositSpeedy.204Ffab8A6E01870": "Confirmă",
	"deposit.depositSpeedy.22E5Dfb74Ead8Aa9": "Nu poate fi gol",
	"deposit.depositSpeedy.B8E774D0E4E5E4C1": "Depunere minimă",
	"deposit.depositSpeedy.F169D816F6Dd83C5": "Depunere maximă",
	"deposit.depositWallet.F64Ec60B1Db4A6D6": "Depune USDT",
	"deposit.depositWallet.551640C76F4Ca4A1": "Monedă de depunere",
	"deposit.depositWallet.B404C543712B71D5": "Rețea de depunere",
	"deposit.depositWallet.A484B0F5E94B3F4F": "Adresă de depunere",
	"deposit.depositWallet.D3980D54Acf242Db": "Salvează cod QR",
	"deposit.depositWallet.A06E84801D6582Be": "Sumă depusă",
	"deposit.depositWallet.Daaaeb1B7B22B126": "Notificare",
	"deposit.depositWallet.D599E40E1Eeec1B3": "Depunere reușită",
	"deposit.depositWallet.4F48Abbafce532Bb": "Trimis cu succes, așteaptă aprobarea serviciului clienți",
	"deposit.depositWallet.A88C481228811696": "Ați refuzat schimbarea rețelei",
	"deposit.depositWallet.C6Ebf27895C21932": "Vă rugăm să activați manual plugin-ul portofelului Tron și să vă conectați",
	"deposit.index.B5491C8Dd09D8183": "Selectați moneda pentru depunere",
	"deposit.index.2F784B2298D39987": "Depunere rapidă",
	"deposit.index.0Daa03Dcdcabd837": "Link OTC",
	"withdraw.bottomSheet.628A63056Ef2D2Fe": "Confirmare retragere",
	"withdraw.bottomSheet.A086Fa20082C849D": "Vă rugăm să vă asigurați că informațiile introduse sunt corecte",
	"withdraw.bottomSheet.Bf8B184D32971501": "Rețeaua de retragere",
	"withdraw.bottomSheet.8758Fd50C87D6C9C": "Adresă",
	"withdraw.bottomSheet.F9Db93B87E08763B": "Sumă",
	"withdraw.bottomSheet.4Ad26475002878C0": "Comision",
	"withdraw.index.A96454041169Af6D": "Selectați moneda",
	"withdraw.index.2A563B7081Dd5B83": "Adresă retragere",
	"withdraw.index.B189C2Ef713Cfff4": "Sumă retragere",
	"withdraw.index.558F35140E84B562": "Disponibil:",
	"withdraw.index.F4E759087E12Cb77": "Retrage tot",
	"withdraw.index.5Cbd9A6B284D25Ae": "Parolă fonduri",
	"withdraw.index.B89Cbe4Bfc33Bb41": "Comision:",
	"withdraw.index.C886De8D8A27026E": "Notificare importantă",
	"withdraw.index.Eac7C5A4095F5606": "1. Pentru a preveni spălarea banilor, se poate solicita retragerea doar după atingerea volumului minim de tranzacții.",
	"withdraw.index.C3Cc7Fff24504Be9": "2. După depunerea cererii de retragere, fondurile vor fi procesate în 24H. Dacă nu primiți fondurile în timpul estimat, vă rugăm să contactați serviciul clienți online.",
	"withdraw.index.0B4Ad7Ccdc833B0D": "3. După depunerea cererii, fondurile vor fi blocate în timpul procesării retragerii. Acest lucru nu înseamnă că ați pierdut fondurile sau că există o problemă.",
	"withdraw.index.4639F3A6E07C00B3": "Pasul următor",
	"withdraw.index.81Fba0D65Cc5C3Aa": "Introduceți sau lipiți adresa portofelului",
	"withdraw.index.25768141C8Bdea91": "Introduceți suma de retragere",
	"withdraw.index.97A85734Cd1B7Bf0": "Introduceți parola fondurilor",
	"withdraw.index.39C7D74B33241C78": "Suma de retragere este incorectă",
	"withdraw.index.86A5D17908197525": "Confirmare retragere, așteptați aprobarea pentru eliberarea fondurilor",
	"withdraw.index.48Fb603C6638C7F6": "Vă rugăm să setați parola fondurilor",
	"withdraw.index.873Ade9A3Bacc2F7": "Notificare",
	"bill.index.5Bbb2A6Ac68D6B2E": "Cont real",
	"bill.index.75751E0Eb8261C40": "Cont simulare",
	"bill.index.Cbc853B37Ecc2E97": "Tip modificare sold",
	"bill.index.4A0Cacddeb2E38B1": "Tip cont",
	"bill.index.F16217028E098B2F": "Monedă",
	"bill.index.A620Dbe6F06B78Ba": "Toate tipurile",
	"bill.index.2C3C148Bb94D9B3F": "Toate conturile",
	"c2C.index.Ab45695E4Bf1E382": "Tranzacție C2C",
	"c2C.index.2702Dc911Dfea762": "Cumpăr",
	"c2C.index.D737D5B8367A53C4": "Vând",
	"c2C.index.C0C540A3Ba9Abe01": "Volum tranzacționat",
	"c2C.index.D8644E8D60C8Bd8A": "Preț unitar",
	"c2C.index.Ebb8670B203D3604": "Limită",
	"c2C.index.F8C6245A2Ebf1D27": "Toate cardurile bancare",
	"c2C.index.F8C6245A2Ebf1D28": "Plată monedă",
	"c2C.index.F8C6245A2Ebf1D29": "Card bancar",
	"c2C.index.Cc3Aa8141Da9Ec9E": "Cumpără",
	"c2C.index.Cc3Aa8141Da9Ec9F": "Vinde",
	"c2C.index.67A39834582Ad99A": "Nu există date",
	"c2C.order.04C23810B47F77F7": "După sumă",
	"c2C.order.6905365902E0A73D": "După cantitate",
	"c2C.order.3F0Ecebbd9D2F23B": "Disponibil",
	"c2C.order.16853Bda54120Bf1": "Tot",
	"c2C.order.Ad3335796F2C95F7": "Sumă totală",
	"c2C.order.61092E27A6879318": "Protejați-vă activele, fiți vigilenți!",
	"c2C.order.0F51881F0Fb920B2": "Informații tranzacție",
	"c2C.order.Dd74Ceca85E5Bc65": "Limită de plată",
	"c2C.order.De3341388A59073F": "30 minute",
	"c2C.order.D334B597A352167F": "Nume vânzător",
	"c2C.order.D334B597A352167G": "Nume cumpărător",
	"c2C.order.9D5F89F99Ced890D": "Metoda tranzacției",
	"c2C.order.8Adf755B14Bc6B7C": "Vă rugăm să citiți următorul conținut mai întâi",
	"c2C.order.686B16F454A7338B": "Transferul bancar nu trebuie să conțină note, altfel fondurile nu vor fi eliberate și contul poate fi blocat. După plată, furnizați o captură de ecran cu detaliile tranzacției (dacă sunt modificate sau ascunse, contul va fi blocat).",
	"c2C.order.9Bec8Fba867B739B": "Selectați metoda de plată",
	"c2C.order.Cf2D892C419Fea36": "Achiziție minimă",
	"c2C.order.7290A6B7456A03E0": "Achiziție maximă",
	"c2C.orderConfirm.F7E99B8C203E2B07": "Detalii comandă",
	"c2C.orderConfirm.036D94Dc2D1Cf7D3": "Comanda a fost creată",
	"c2C.orderConfirm.0F5433503F3845Ce": "Vă rugăm să efectuați plata către vânzător în timpul afișat",
	"c2C.orderConfirm.24C3Bcacdb85A451": "Așteptare plată de la cumpărător",
	"c2C.orderConfirm.8E8140D7Ab607B24": "Contactați vânzătorul",
	"c2C.orderConfirm.8E8140D7Ab607B25": "Contactați cumpărătorul",
	"c2C.orderConfirm.Ec4D8722Ec15C813": "Criptomonedele vânzătorului au fost depuse în contul escrow, plătiți cu încredere",
	"c2C.orderConfirm.69D1Fbbc7700C1Ab": "Numele real al cumpărătorului:",
	"c2C.orderConfirm.E5Ed8Ec53Edcd5D3": "Suport clienți 7x24 ore",
	"c2C.orderConfirm.Abf9F4B8C93D641E": "Număr comandă",
	"c2C.orderConfirm.726C51702F70C486": "Data creării",
	"c2C.orderConfirm.E097Bb9B1216Bfd8": "Contactați suportul",
	"c2C.orderConfirm.103408Fbbe30287F": "Anulează comanda",
	"c2C.orderConfirm.4E93Df1Fb521F4Ba": "Am confirmat plata",
	"c2C.orderConfirm.3B5418Dbea7Ebfe4": "Plată efectuată",
	"c2C.orderConfirm.387Ca3625B260E4E": "Ați plătit această comandă",
	"c2C.orderConfirm.7C83D5F1Db1A08B7": "Tranzacție anulată",
	"c2C.orderConfirm.76C86566Cc3751C0": "Comanda a fost anulată",
	"c2C.orderConfirm.205B349751D176B4": "Plată reușită",
	"c2C.paymentAdd.6F2A7Dcc66E6Acba": "Metoda de plată",
	"c2C.paymentAdd.C87E865Df6800304": "Configurare metodă plată",
	"c2C.paymentAdd.B59Ae0F1B1C235Df": "Tip metodă plată",
	"c2C.paymentAdd.06910Bddf002695F": "Nume real",
	"c2C.paymentAdd.3E33Ae3Efa7507Dd": "Cont PayPal",
	"c2C.paymentAdd.3E33Ae3Efa7507De": "Număr cont/card bancar",
	"c2C.paymentAdd.3E33Ae3Efa7507Df": "Numele monedei",
	"c2C.paymentAdd.595Ede91Abf6F6E0": "Cod QR plată",
	"c2C.paymentAdd.1Ecc8Be9Ba1C940A": "Faceți clic pentru a încărca",
	"c2C.paymentAdd.6Daae340F2E9718A": "Numele băncii",
	"c2C.paymentAdd.347751415C3Da489": "Numele blockchain-ului",
	"c2C.paymentAdd.15B3627Faddccb1D": "Observații",
	"c2C.paymentAdd.86Da96Cbd274058F": "Notă: Când vindeți criptomonede, metoda de plată aleasă va fi afișată cumpărătorului. Vă rugăm să verificați acuratețea datelor introduse.",
	"c2C.paymentAdd.4Ce9979Bfb6576D9": "Salvează",
	"c2C.paymentAdd.90D2A3A5C07179C0": "Vă rugăm să introduceți numele real",
	"c2C.paymentAdd.A3B0Cd3Ad9Ca3475": "Vă rugăm să introduceți ",
	"c2C.paymentAdd.Ec389E6190Eedb62": "Vă rugăm să introduceți numele băncii",
	"c2C.paymentAdd.9Be51Fb1E9025Fb2": "Vă rugăm să introduceți numele blockchain-ului",
	"c2C.paymentAdd.94F034F0E01439E0": "Vă rugăm să introduceți adresa",
	"c2C.paymentAdd.B12E035663A42B32": "Toate cardurile bancare",
	"c2C.paymentAdd.C7B677F393A8F8Ac": "Plată monedă",
	"c2C.paymentAdd.Abafe11737Bab7Cd": "Vă rugăm să încărcați codul de plată",
	"c2C.paymentAdd.07C443212Ff04Bfb": "Adăugat cu succes",
	"c2C.paymentDetail.86Da96Cbd274058F": "Notă: Când vindeți criptomonede, metoda de plată aleasă va fi afișată cumpărătorului. Vă rugăm să verificați acuratețea datelor introduse.",
	"c2C.paymentDetail.C4C613Da60226De4": "Modificare reușită",
	"c2C.paymentMethod.7609F7C8337C7A17": "Metode plată C2C",
	"c2C.records.9E36893D5736Abb4": "Lista comenzilor",
	"c2C.records.4B53F9A5B13B3235": "Așteaptă plată",
	"c2C.records.4B53F9A5B13B3236": "Tranzacție anulată",
	"c2C.records.4B53F9A5B13B3237": "Plată efectuată",
	"contract.index.9706Df877458F0Be": "Marjă integrală",
	"contract.index.623Fc7D3D40Aa479": "Marja inițială",
	"contract.index.F92Dce1169330387": "Închidere totală la preț de piață",
	"contract.index.3598B97Dd28Dbf20": "Vă rugăm să introduceți cantitatea (contracte)",
	"contract.index.6E1Fae821Dc0B797": "Perpetuu",
	"contract.index.Eb07Eb0C37C14575": "Livrare",
	"contract.index.Eb6492F19B1C1Fb6": "Detalii tranzacții istorice",
	"contract.index.873Ade9A3Bacc2F7": "Notificare",
	"contract.index.Ff63B0F93D39F50B": "Ești sigur că dorești să",
	"contract.index.Ff63B0F93D39F50D": "cumperi (long)",
	"contract.index.Ff63B0F93D39F50E": "vinzi (short)",
	"contract.index.Ff63B0F93D39F50F": "pe",
	"contract.index.Ff63B0F93D39F50G": "închizi toate pozițiile?",
	"customer.dialog.3D410C88E8A24Fe8": "Confirmă nickname-ul",
	"customer.dialog.4B3340F7872B411F": "Anulează",
	"customer.dialog.549B1456Bb5F98B3": "Vă rugăm să introduceți nickname-ul dvs.",
	"customer.dialog.B773B3E45Ccfad00": "Nickname-ul este gol",
	"customer.index.7308C6B849D159E9": "Detalii imagine",
	"delivery.callDialog.C74F562C3Fe91Fe3": "Comandă plasată cu succes",
	"delivery.callDialog.B8C98F42Caa15Ca5": "Direcție",
	"delivery.callDialog.B79A581Dae543974": "Cumpărare long",
	"delivery.callDialog.B79A581Dae543975": "Cumpărare short",
	"delivery.callDialog.3B26F0F7E90773F3": "Preț de deschidere",
	"delivery.callDialog.65Fb252Bd94E1039": "Profit estimat",
	"delivery.index.B483Ba4Fce633539": "Livrare",
	"delivery.index.224Dd6Cb58D58249": "Perioadă tranzacționare",
	"delivery.index.28158F517E902788": "Cumpărare minimă",
	"delivery.index.A1232162B14Bec76": "Comenzi livrare",
	"delivery.index.445B1D3176D9C69D": "Comenzi istorice",
	"delivery.index.Ab6Cb86E28653C5C": "Livrare",
	"delivery.index.20A7A6F14D3698C0": "Timp deschidere poziție",
	"delivery.index.Ec6821A49395Ddc2": "Timp închidere poziție",
	"delivery.index.254Fdc665C391743": "Preț închidere",
	"delivery.index.2A0C5E68B44A472A": "Profit/Pierdere",
	"delivery.index.E05B33309F6D236A": "Vă rugăm să introduceți cantitatea",
	"delivery.index.B2899E073Cb355D9": "Cumpărare minimă",
	"download.description.869467A93C7Dd4A1": "Instrucțiuni instalare",
	"download.description.C80C1Edd6Bee12Bc": "1. Permiteți descărcarea profilului de configurare",
	"download.description.2F5Bc180F92642B4": "2. Profilul de configurare a fost descărcat",
	"download.description.3C3B849F6Ccf712F": "3. Accesați Setări pe telefon, profilul descărcat va apărea sub informațiile contului",
	"download.description.86Affd862985E045": "4. Apăsați pe profilul descărcat",
	"download.description.32832492Bfc1D95E": "5. Apăsați Instalare",
	"download.index.245883C80F181C4A": "Descarcă",
	"download.index.Ef3De8Cb2722937A": "Tranzacționează oriunde, oricând",
	"download.index.F4A87Eaeed691638": "Fii la curent cu cele mai noi informații prin aplicația noastră",
	"download.index.Ad3Aba52D0D39D01": "Descarcă pachetul de instalare",
	"download.safariGuide.61Bd9A8Fcc2Ea788": "Notă importantă",
	"download.safariGuide.2Cc68Aaadf623477": "Accesați prin Safari",
	"download.safariGuide.C80Fff2A6Ff4E768": "Accesați site-ul descentralizat în aplicația Safari",
	"download.safariGuide.06Da016F3E2F79Bd": "Copiază linkul",
	"finance.index.B034B367545D5236": "Proiecte premium globale",
	"finance.index.6Ebfac2C0A9228B0": "Peste 1,6 milioane utilizatori activi, 122,4 miliarde $",
	"finance.index.52Bdcaf19659363D": "Mining de lichiditate",
	"finance.index.D66924272B031Bf5": "Randamente anuale foarte ridicate",
	"finance.index.34789D88Afcefa64": "Vezi proiectul",
	"finance.index.E12676B95654D21E": "Împrumuturi cu garanție",
	"finance.index.4C924Cfd89A11Ac7": "Descoperă mai multe oportunități de tranzacționare",
	"finance.index.C251D4B594Da2848": "Trading AI",
	"finance.index.4E53Cf2E5F173Dd3": "Închiriere cu un click, tranzacționare inteligentă AI",
	"finance.records.Cce168301447D1Ba": "În derulare",
	"finance.records.4587B6Bd7Cfa4454": "Răscumpărat",
	"finance.records.18685418E3A50147": "Mining",
	"finance.records.Df9Fd438F97Cc908": "Zile",
	"finance.records.E23Cb03C5Ad359E5": "Termen",
	"finance.records.Bd87Dac6Cba7Eba8": "Cantitate cumpărată",
	"finance.records.2D0Fff99265E8B1A": "Profit realizat",
	"finance.records.2D0Fff99265E8B1B": "Profit la scadență",
	"finance.records.024F5F0B851782De": "Timp mining:",
	"finance.records.3143A26D3F983896": "Timp răscumpărare:",
	"finance.records.96574Aaf8Db85Ead": "Răscumpărare anticipată",
	"finance.records.531E1829203181Ac": "Sigur doriți să răscumpărați anticipat?",
	"finance.records.9205843B8923Dac3": "Răscumpărare reușită",
	"loan.applyCallback.B9258Ec8746A74D8": "Canal împrumut",
	"loan.applyForm.7B8Ed340400A6E2B": "Prenume",
	"loan.applyForm.549A44Bae725F4A2": "Nume de familie",
	"loan.applyForm.2A27E61375E7Fea8": "Data nașterii",
	"loan.applyForm.89925B019D537738": "Adresă de email",
	"loan.applyForm.Afaeb32Cb4D62E28": "Adresă domiciliu (inclusiv numărul apartamentului)",
	"loan.applyForm.E05B5D049B64B040": "Oraș",
	"loan.applyForm.B166E4E8Fe9513Fa": "Țară",
	"loan.applyForm.83Aaede109E395F8": "Cod poștal",
	"loan.applyForm.647Ed21332A4968B": "Venitul lunar",
	"loan.applyForm.Cf0A9B845D34D4B4": "Venit suplimentar (opțional)",
	"loan.applyForm.7048F618Acc6A54C": "Chirie sau rată lunară ipotecară",
	"loan.applyForm.15C1Bba18Ae18545": "Spuneți-ne dacă aveți o garanție ipotecară",
	"loan.applyForm.3921E90625A84E36": "Neselectarea garanției scade șansele de aprobare",
	"loan.applyForm.262Eec4F8906B0F6": "Aveți garanție ipotecară?",
	"loan.applyForm.8634Eb21B6910F21": "Vă rugăm să selectați tipul de garanție",
	"loan.applyForm.A4897B3A331B5E61": "Documente de tranzacție",
	"loan.applyForm.6623384C683De457": "Să rămânem în contact",
	"loan.applyForm.A8360Bdba86834Cb": "Dacă avem nevoie de informații suplimentare privind cererea dvs., vă vom contacta la acest număr",
	"loan.applyForm.C1C373F385A4C7B3": "Număr de telefon",
	"loan.applyForm.1B9785Badb91191F": "După completarea datelor, așteptați evaluarea sistemului.",
	"loan.applyForm.8755B9C761D4080C": "Am citit și sunt de acord cu semnătura electronică",
	"loan.applyForm.3E987B787468148C": "Termeni de utilizare și acord electronic",
	"loan.applyForm.Bc54E76B61C50Fb9": "Vă rugăm să citiți și să acceptați acordul",
	"loan.applyForm.89E158384F634Eb8": "Înapoi la pasul anterior",
	"loan.applyForm.Efa5A4548E2F3510": "Adresă domiciliu",
	"loan.applyForm.4Cadf1787541B35D": "Da",
	"loan.applyForm.Fab408D2F4100447": "Nu",
	"loan.applyForm.3Bad7A307480Cc56": "Format email invalid;",
	"loan.applyForm.306322F49B36855D": "Cererea a fost trimisă, așteptați aprobarea serviciului clienți",
	"loan.applyForm.3C6E0E858C995Ff9": "Vă rugăm să încărcați documentele de tranzacție",
	"loan.applyForm.2Bf443476B271376": "Puteți încărca până la 4 imagini",
	"loan.applyQuota.Ef1D8E23003B9A6F": "Canal de împrumut",
	"loan.applyQuota.Ef1D8E23003B9A6G": "Obțineți limita de împrumut",
	"loan.applyQuota.9E0780F9352C7273": "Sold portofel",
	"loan.applyQuota.Cbc1Eb9D639A6105": "Limita totală disponibilă pentru împrumut",
	"loan.applyQuota.033A05462195B080": "Limita împrumutată",
	"loan.applyQuota.9Aa89B036Ef4821D": "Limita rămasă",
	"loan.applyQuota.5656Fb52Ef17A557": "Obțineți limita de împrumut",
	"loan.applyQuota.6Ff6702B4C917D40": "În curs de evaluare",
	"loan.applyQuota.6Ff6702B4C917D41": "Respins",
	"loan.applyQuota.6Ff6702B4C917D42": "Acceptat",
	"loan.applyQuota.0Bad0E857Ea4A952": "Data solicitării",
	"loan.applyQuota.3E7E56E2De2Cc546": "Limita solicitată",
	"loan.applyQuota.8F1D170D9E54Af5B": "Stadiul solicitării",
	"loan.applyQuota.6167Ca035B93Caf3": "Motiv",
	"loan.applyQuota.410C7954F9A3981D": "Solicită din nou",
	"loan.bottomSheet.61Cd62F861D8F5B2": "Vă rugăm să selectați moneda",
	"loan.index.4C10307B22E885C3": "Descoperiți mai multe oportunități de tranzacționare pentru a crea bogăție",
	"loan.index.Ae8D37Dea2B3717B": "Rata dobânzii",
	"loan.index.1Bb54625682E85Db": "Introducere în reguli",
	"loan.index.5Bd31Fab681C6E9D": "Vezi mai mult",
	"loan.index.111F95F404814327": "Monedă împrumut",
	"loan.index.6Bc2723B3Bec106D": "Împrumut",
	"loan.index.3200106280E6E370": "Rata dobânzii",
	"loan.index.049A6Ccb6C81A635": "Cantitate împrumut (minim/maxim)",
	"loan.productDetails.5037Ad86Ab4B7E02": "Împrumut",
	"loan.productDetails.37181C74559Db182": "Comandă",
	"loan.productDetails.5802Aaf06A1E4755": "Lichiditate disponibilă",
	"loan.productDetails.89Aea9Cf9337C40F": "Cantitate disponibilă pentru împrumut",
	"loan.productDetails.9E419Ae2D06F3Ad9": "Cantitate de rambursat",
	"loan.productDetails.C65F329Ef14C4A3D": "Cantitate împrumutată",
	"loan.productDetails.3A74667815Adc8Bf": "Maxim",
	"loan.productDetails.Ab851D8351573227": "Zile",
	"loan.productDetails.Ddf82D8A2C8F46A0": "Perioada de rambursare",
	"loan.productDetails.C105E5562005Aeb1": "Zile",
	"loan.productDetails.3F346Be2137F0756": "Cantitate împrumut (minim/maxim)",
	"loan.productDetails.2707F78Df864E194": "Dobândă",
	"loan.productDetails.B9Dc9B81E726Bdf1": "Vă rugăm să rambursați la timp; dacă întârzierea apare, se va percepe zilnic o taxă suplimentară de",
	"loan.productDetails.B9Dc9B81E726Bdf2": "% din suma (principal + dobândă) ca penalitate de întârziere",
	"loan.productDetails.4D94Faa033Be7356": "Sunt de acord cu",
	"loan.productDetails.62429A957A22780A": "Acordul serviciului de împrumut",
	"loan.productDetails.Bc54E76B61C50Fb9": "Vă rugăm să citiți și să acceptați acordul",
	"loan.productDetails.Ec8Ba071C53A67Cb": "Împrumut imediat",
	"loan.productDetails.59246A0Bf081D398": "Minim",
	"loan.productDetails.Ec3F1172B71Cd36C": "Cantitate minimă",
	"loan.productDetails.7Ccc4Cf1D81930B3": "Cantitate maximă",
	"loan.productDetails.071488598990Aa68": "Vă rugăm să citiți și să acceptați acordul;",
	"loan.productDetails.579Dd216D3339119": "Împrumut efectuat cu succes;",
	"loan.records.4951B36Fd0D2A831": "Istoric împrumuturi",
	"loan.records.Bb0Aaa30514B7Cba": "Înregistrări curente",
	"loan.records.0F8B0A7D80769051": "Istoric rambursări",
	"loan.records.D4B42E43D88De6F1": "Istoric complet",
	"loan.records.Cb1847D6281897E6": "Sumă împrumutată",
	"loan.records.C7Bfcacfc2Adea58": "Sumă rambursată",
	"loan.records.8B369164D5Fea340": "Data împrumutului:",
	"loan.records.Ab2402Ad3Ffd35E7": "Rambursare anticipată",
	"loan.records.B7A0Ca0C195D0Cd1": "Data acordării:",
	"loan.records.42014Bdcfd9C411B": "Data rambursării:",
	"loan.records.A0Acfaee54F06458": "Finalizat",
	"loan.records.67A39834582Ad99A": "Nu există date",
	"loan.records.6A687Ff5B8F1598F": "Sunteți sigur că doriți să rambursați anticipat?",
	"loan.records.7C20D7008D0Eae86": "Rambursare reușită",
	"mining.bottomSheet.Ba91637D32Ccba04": "Minerit lichiditate",
	"mining.bottomSheet.7De3D636A165E008": "Rata de profit",
	"mining.bottomSheet.F3003345B189D683": "Perioada mineritului",
	"mining.bottomSheet.3E4C0A8C533F5848": "Tip monedă",
	"mining.bottomSheet.Adcba368993Ae65E": "Suma subscrisă (minim/maxim)",
	"mining.bottomSheet.94743B24E4Ed4166": "Fără restricții",
	"mining.bottomSheet.286944Fedd211257": "Fonduri disponibile",
	"mining.bottomSheet.7B5766Dc65Abc0C3": "Profit estimat:",
	"mining.bottomSheet.9Bbaf80Fdb6Fd148": "Minerați acum",
	"mining.bottomSheet.Bb1493C567C114Dd": "Notă:",
	"mining.bottomSheet.D2315E87E34A3Bd3": "Taxă pentru răscumpărare anticipată",
	"mining.index.8B2Bba1422Eed6F0": "Creați avere de miliarde, profit 100% curat",
	"mining.index.42997E300086Ee89": "Profit maxim",
	"mining.index.510F74F42052Ecce": "Produse minerit",
	"mining.index.B853F96626106912": "Mergeți la minerit",
	"mining.productList.37181C74559Db182": "Comandă",
	"mining.productList.Aac5B810004C46C8": "Perioadă fixă",
	"mining.productList.D2Fb4F78C387D888": "Mineritul a fost realizat cu succes",
	"quantify.bottomSheet.9Ea4A318F690Bc95": "Confirmare comandă",
	"quantify.bottomSheet.6915303B698303B1": "Robot",
	"quantify.bottomSheet.68045296Dd0F8Ad6": "Suma închiriată",
	"quantify.bottomSheet.Fbd931286Be387Aa": "Perioadă",
	"quantify.bottomSheet.9Ad84Db481807844": "Fără limită de timp",
	"quantify.bottomSheet.994D7226Ca083Ea5": "Randament zilnic",
	"quantify.bottomSheet.0Bf82Ee4Bfe063B7": "Data începerii dobânzii",
	"quantify.bottomSheet.88008603Ba7Bde64": "Achiziție reușită",
	"quantify.bottomSheet.Ff50B3091Bbd09Ab": "Începând de azi puteți primi dividende!",
	"quantify.bottomSheet.C778A674C4A054F9": "Vezi comanda",
	"quantify.bottomSheet.685Dad322B7029B0": "Înapoi la tranzacționare",
	"quantify.buyForm.Acf8560A04334E95": "Suma de cumpărat",
	"quantify.buyForm.Cf9Cfbc2C554944F": "Prezentare generală",
	"quantify.buyForm.8788Df2B625E97B5": "Robot",
	"quantify.buyForm.50Ca63B45E881D50": "Data distribuirii dividendelor",
	"quantify.buyForm.Fcda03Adbc5Fca97": "Zilnic",
	"quantify.buyForm.Afb89504Fc399189": "Vă rugăm să introduceți cantitatea de cumpărat",
	"quantify.buyForm.1435Afdfb4Ec0596": "Cantitatea minimă de cumpărat",
	"quantify.buyForm.1B97F1730Bacd839": "Cantitatea maximă de cumpărat",
	"quantify.index.32F56C9B7D0E250A": "Perioadă: Nelimitată",
	"quantify.index.E34F028D00904630": "Preț",
	"quantify.index.E34F028D00904631": ", randament zilnic",
	"quantify.productDetail.6Bbe178Df539A5Ca": "Suma în custodie",
	"quantify.productDetail.53635B53Bca31Dfa": "Randament zilnic estimat",
	"quantify.productDetail.F9E46449A6269E09": "Profit acumulat",
	"quantify.productDetail.98Fc46B1B8C993B2": "Custodia comenzii",
	"quantify.productDetail.93624Bb045830966": "Închiriază acum",
	"quantify.records.0C16A18C32B9Cf4A": "Istoric comenzi",
	"quantify.records.B191F5614B0E2312": "Istoric achiziții",
	"quantify.records.6A06033B86A73F7C": "Istoric răscumpărări",
	"quantify.records.45E0F7E71611618E": "Profit acumulat",
	"quantify.records.45E0F7E71611618F": "Profit la scadență",
	"quantify.records.Aae1201E38C4Baaa": "În desfășurare",
	"flash.index.C41Fd4F2Fdfa594B": "Consum",
	"flash.index.1Ac59Fa2218E3B00": "Disponibil:",
	"flash.index.Bf7233A660821549": "Câștigat",
	"flash.index.548E775Dd67C7472": "Confirmă schimbul",
	"flash.index.066A2449Bd616F03": "Vă rugăm să introduceți cantitatea pentru schimb",
	"flash.index.Fca26Fcf9C06563F": "Schimb realizat cu succes",
	"message.index.40031524233F4564": "Centrul de mesaje",
	"message.index.8E5586210Fd44D69": "Alerte poziții perpetue",
	"message.index.Bcd3F470E88C197D": "Nu există notificări",
	"message.index.23A557Fbce545879": "Notificare lichidare poziție perpetuă",
	"message.index.B5E19B36B5125550": "Alerte retrageri",
	"message.index.716A981465138334": "Alerte depuneri",
	"message.index.884474Ebff2977Ba": "Mesaje sistem",
	"message.index.08Cc7D24752Ec42C": "Serviciu clienți online",
	"message.index.1D820A6A19Ab025D": "Serviciu clienți 7x24 ore, asistență umană",
	"more.index.29881E0B5Df58Bf7": "Mai multe funcții",
	"more.index.C77Ee35911D10D9D": "Funcții frecvente",
	"more.index.3558F69B0260Be61": "Funcții de tranzacționare",
	"more.index.7243Fe610Ed98Cec": "Cont real",
	"more.index.7243Fe610Ed98Ced": "Cont demo",
	"more.index.693C7B35Bdf3E3A3": "Finanțe",
	"more.index.F855997Fac114554": "Centrul de ajutor",
	"more.index.Ae9A1252278Da742": "Ajutor",
	"more.index.Ace012504Bc529E0": "Mesaje",
	"more.index.05682Dbef5Eeb0A8": "Serviciu clienți",
	"more.index.C7Af227A5D5C7Bb9": "Ați trecut pe contul real",
	"more.index.D818A65592694786": "Ați trecut pe contul demo",
	"notice.details.B360807Dbe727E6E": "Despre noi",
	"notice.details.92F2552F695E70E3": "Despre noi",
	"notice.details.7Aaceaf69B67F3D1": "Introducerea regulilor",
	"notice.index.6128438Be34Bcb9F": "Notificări perpetue",
	"notice.index.71627F5Eb7128261": "Notificări retragere",
	"notice.index.2Dce570Fda841705": "Notificări depunere",
	"notice.index.228A7C9C6448A9B1": "Notificări sistem",
	"setting.dialog.8B4F5B74660Deabe": "Configurare culori",
	"setting.dialog.Bfc7D25486Ebc1A9": "Verde crește, roșu scade",
	"setting.dialog.796Ea0E1A82C320B": "Roșu crește, verde scade",
	"setting.index.8Ddc5864E1739466": "Preferințe",
	"setting.index.F5205801D57D6727": "Limba",
	"setting.index.2E2C12Dd0Cc1B63B": "Moneda de evaluare",
	"setting.index.322D8496Aec3D918": "Versiune",
	"setting.index.Aa7E6C204C751Cfa": "Deconectare",
	"share.index.75Bc38Bbf7D2E766": "Invită prieteni",
	"share.index.45575Eb5D42213E6": "Codul meu de invitație",
	"share.index.29F67F0644A78Bf3": "Copiază",
	"share.index.19Cc65Bb6Bb98Fe7": "Linkul meu de invitație",
	"share.index.5372712F162Fb78B": "Număr direct de invitați",
	"share.index.C88D6B95E3Ab7D6F": "Număr total de invitați",
	"share.index.Bb5Fa5471Aeecc62": "Comision direct",
	"share.index.426B6Bac9A5F3D4F": "Comision total",
	"share.index.197E4A428F0401C9": "Vezi istoricul comisioanelor",
	"share.records.88A6B2E2B74B13C4": "Istoric comisioane",
	"share.records.B671A35Ffdc93B89": "Comision",
	"transfer.index.B17617A869C03Ca5": "Portofel",
	"transfer.index.E4116Dcc6F6C7270": "Transfer realizat cu succes",
	"transfer.index.48Fb603C6638C7F6": "Vă rugăm să setați parola fondurilor",
	"transfer.records.Eb0E39Eb5911D418": "Obținut",
	"transfer.records.977554Be0Aa65052": "Timp schimb rapid:",
	"transfer.records.9Aa33884Aa400B7C": "Timp transfer:",
	"form1.forget.76636Db8Fae5B124": "Adresa dvs. de email",
	"form1.forget.35354B9Cca1Bb0E6": "Cod de verificare email",
	"form1.forget.604A0B11E916F387": "Parolă",
	"form1.forget.9Cb1C9C51E7503D6": "Confirmare parolă",
	"form1.forget.3A4F7E04B008453C": "Numărul dvs. de telefon",
	"form1.forget.Cf11Dce5B4713B5A": "Cod de verificare telefon",
	"form1.forget.3012Edba57D4F297": "Vă rugăm să introduceți adresa de email",
	"form1.forget.F1Ee1D97E869E447": "Vă rugăm să introduceți codul de verificare",
	"form1.forget.3A5C4C9Ae68Fa0F6": "Vă rugăm să introduceți parola",
	"form1.forget.C6Cb174Da411D5F7": "Vă rugăm să introduceți numărul de telefon",
	"form1.forget.947B3B21Ee45E582": "Trimite",
	"form1.forget.3E0580F1E8630Df6": "Parolele nu coincid",
	"form1.forget.C5A61836B8Cc74C6": "Parola a fost modificată cu succes, redirecționare...",
	"form1.forget.B96D072Bc8962565": "Retrimite",
	"form1.login.2B72C27Ff828Cfc4": "Parola dvs.",
	"form1.login.D7C6B872Af9Cb17F": "Ține-mă minte",
	"form1.login.0Fff44C827A4F3B6": "Autentificare",
	"form1.login.1B7F2C1Ede3990Cc": "Nu aveți încă un cont? Înregistrați-vă acum",
	"form1.login.F657F7Be1Cc33Bd2": "Ați uitat parola",
	"form1.login.2074A1Eec4B088B0": "Autentificare portofel",
	"form1.login.1B8938Fbcc3C9B56": "Autentificare reușită, redirecționare...",
	"form1.login.07162A7Bb9310555": "Vă rugăm să instalați portofel ERC20",
	"form1.login.766969966Ae151Dc": "Vă rugăm să instalați portofel TRC20",
	"form1.login.B88171E1Ad4C50Bf": "Ați refuzat schimbarea rețelei",
	"form1.register.Aaef0710Cb4Db554": "Introduceți din nou parola",
	"form1.register.54Dfea0415C708Ff": "Cod invitație",
	"form1.register.6839940Dac08C794": "Înregistrare",
	"form1.register.9901A3B5550Aa58E": "Aveți deja un cont? Autentificare",
	"form1.register.2548Ca53785252Ea": "Vă rugăm să introduceți codul invitației",
	"form1.register.Dd71Fd65900Dd03E": "Vă rugăm să citiți și să acceptați acordul de înregistrare",
	"form1.register.7975613909490B77": "Înregistrare reușită, redirecționare...",
	"form1.walletDialog.105829Acfc0Bd6Aa": "Alege portofelul",
	"userc.certification.2Af9511640153D2E": "Certificare nivel 1",
	"userc.certification.177B191D8E0Fa84D": "Neconfirmat",
	"userc.certification.601218D4D572E98A": "Confirmat",
	"userc.certification.6E37C51Ba9012Fc8": "Respins",
	"userc.certification.1B9B563E05C96474": "Certificare nivel avansat",
	"userc.certification.1418B83803Ab56B4": "Vă rugăm să finalizați mai întâi certificarea nivel 1",
	"userc.creditScore.0B149112601Acc4D": "Scor de credit",
	"userc.creditScore.88Ac7F84E106C5F6": "Scor total de credit",
	"userc.creditScore.3E1D6E0E7F1E6155": "Evaluare sistem",
	"userc.index.62Eac58D04Bbca0F": "Centru personal",
	"userc.index.F4Cac53F93Cb2Aff": "Tranzacționare demo",
	"userc.index.42F409Fdf3559773": "Centrul de securitate",
	"userc.index.1B8E211009807Db8": "Verificare identitate",
	"userc.index.Bdfcf21Eb8F2Eb70": "Istoric modificări cont",
	"userc.index.6C18D67F6D19586B": "Despre platformă",
	"userc.index.807A814Ed58A93Bc": "Șterge cache",
	"userc.index.E43Daad59759611C": "Neconfirmat",
	"userc.secureCenter.F5C70F0Db2F1Ba76": "Schimbă parola de autentificare",
	"userc.secureCenter.1F37Ba427Debf24A": "Legare cont",
	"userc.secureCenter.F9A5Ffa750664004": "Leagă Google Authenticator",
	"userb.certificationForm.7685Af7D30043Cd6": "Certificare nivel 1",
	"userb.certificationForm.7685Af7D30043Cd7": "Certificare nivel avansat",
	"userb.certificationForm.70E37C35Abc3F462": "Țara de reședință",
	"userb.certificationForm.F92C25A68E4D08C5": "Oraș",
	"userb.certificationForm.0Ccc6387B38E0318": "Numele dvs.",
	"userb.certificationForm.94C67Bba370Fdd46": "Număr document",
	"userb.certificationForm.B2D4C7Fffe79258E": "Email",
	"userb.certificationForm.57554268761Fb47A": "Încărcați fața documentului",
	"userb.certificationForm.D79E90201F5319Bd": "Încărcați verso document",
	"userb.certificationForm.9C6Bad08Af29E20E": "Încărcați o poză cu documentul în mână",
	"userb.certificationForm.F96B62Dfa31Cde45": "Trimiteți",
	"userb.certificationForm.2125D78Ea8C6D287": "Cerințe încărcare",
	"userb.certificationForm.0D64864D3076A824": "Vezi exemplu",
	"userb.certificationForm.35287Deb72281E87": "1. Documentul trebuie să fie lizibil.",
	"userb.certificationForm.3007F2E01Efc7B57": "2. Fotografia trebuie să fie reală, fără modificări.",
	"userb.certificationForm.25A90660554319F9": "3. Numărul documentului și numele trebuie să fie clare. Sunt acceptate JPG / JPEG / PNG.",
	"userb.certificationForm.5A9Aefbc03C778F7": "Vă rugăm să introduceți",
	"userb.certificationForm.3B7A1D8Ce27C937E": "Trimitere reușită, vă rugăm să așteptați verificarea",
	"userb.certificationForm.744Bd07D8Abd2513": "Vă rugăm să încărcați fața documentului dvs.",
	"userb.certificationForm.6De1C319130F7Fef": "Vă rugăm să încărcați verso documentului dvs.",
	"userb.certificationForm.79F8E8B172E30C8A": "Vă rugăm să încărcați poza dvs. ținând documentul în mână",
	"userb.certificationForm.46412E16D28A4753": "Încărcarea fotografiei a eșuat",
	"userb.changeDialog.676B0Adca1F8Eea4": "Schimbă parola",
	"userb.modifyInfoDialog.F41De3A1Fa69135A": "Număr de telefon",
	"userb.modifyInfoDialog.3C3Aac9664A35Ef8": "Comutator autentificator",
	"userb.modifyInfoDialog.62149E566814154C": "Selectați autentificatorul",
	"userb.modifyInfoDialog.8E69468E2435Fc89": "Deschideți aplicația de autentificare și apăsați +",
	"userb.modifyInfoDialog.7625E5Bdcbfe9963": "Selectați 'Scanează cod QR' sau 'Introduceți cheia'",
	"userb.modifyInfoDialog.93F094E2B4369472": "Scanați codul QR sau introduceți cheia",
	"userb.modifyInfoDialog.43E4F1532529Ee1E": "Dezactivare/activare",
	"userb.modifyInfoDialog.Bae6358Dfd95025A": "Parola veche pentru fonduri",
	"userb.modifyInfoDialog.E1133Cd4B1C2Abb7": "Parola nouă pentru fonduri",
	"userb.modifyInfoDialog.C1Ce0403A2523Ee0": "Confirmați parola nouă pentru fonduri",
	"userb.modifyInfoDialog.8Dd453Adc2Cd78Fb": "Confirmați parola fondurilor",
	"userb.modifyInfoDialog.Bb0D9854C79325Bb": "Vă rugăm să introduceți parola veche pentru fonduri",
	"userb.modifyInfoDialog.E66Cb29B00Bc54D1": "Vă rugăm să introduceți parola nouă pentru fonduri",
	"userb.modifyInfoDialog.E8Ae2Ec5Df401255": "Vă rugăm să introduceți parola fondurilor",
	"userb.modifyInfoDialog.258A534498Fe984F": "Vă rugăm să confirmați parola fondurilor",
	"userb.modifyInfoDialog.768Ec43Faa193F08": "Legare cont",
	"userb.modifyInfoDialog.D34746090C25E5Db": "Parola fondurilor",
	"userb.modifyInfoDialog.E4F27D8916E5E536": "Confirmare",
	"userb.modifyInfoDialog.Bef7160Ce53773E0": "Autentificator dezactivat",
	"userb.modifyInfoDialog.Be8Bf47Ba6820De1": "Google Authenticator activat cu succes",
	"userb.modifyInfoDialog.24Dba26593F43C74": "Parola fondurilor a fost schimbată cu succes",
	"userb.modifyInfoDialog.5C369D42Dc7Dbe76": "Parola fondurilor a fost setată cu succes",
	"userb.modifyInfoDialog.667Bf8D0B6C36D4C": "Legare reușită",
	"userb.modifyInfoDialog.1C5E05Efee2B0B9F": "Codul de verificare este greșit",
	"userb.veBottomSheet.Eecc4683C725F6F2": "Exemplu încărcare document",
	"userb.veBottomSheet.6F38A0D5858633Ee": "Fundal întunecat și curat",
	"userb.veBottomSheet.Af162Dbdfc4Fcae9": "Iluminare suficientă",
	"userb.veBottomSheet.0F7Baf0Cee3C8141": "Aliniați în caseta de asistență",
	"userb.veBottomSheet.Ac9E471Eead0Cf11": "Fotografie clară",
	"userb.veBottomSheet.50B741382E71F103": "Motive posibile pentru eșec",
	"userb.veBottomSheet.Aa56C68E8Fd4Cfb4": "Carcasa pentru buletin nu a fost îndepărtată",
	"userb.veBottomSheet.5D2F429C75D4C7F2": "Fundalul este dezordonat",
	"userb.veBottomSheet.90F42D3Cb7769Dbc": "Reflexii pe buletin",
	"userb.veBottomSheet.1Ee78Cee782D81B4": "Iluminare slabă/umbră de la telefon",
	"userb.veBottomSheet.1A75D2Fc2614592B": "Țineți buletinul în mână",
	"home.home.C3525Eb110Db58Aa": "Mai mult",
	"home.home.29761532Fc8Ebecc": "Tranzacționare",
	"home.home.F15Ea99Bfa6E1848": "Autentificare sigură, cumpărați U cu încredere",
	"home.home.46E1Ab39Bae7182A": "Rapid",
	"home.home.Fde2Eb7F6F3Dd800": "Tranzacții rapide, operare simplă",
	"home.home.Ea4756Bc1642E0F1": "Nume",
	"home.home.B6B1127Ede1C97B4": "Ultimul preț",
	"home.home.3587Ad870Eb0Ab86": "Schimbare 24H",
	"home.home.Cb1A4E14Ec2Cd2B5": "Descoperă",
	"home.home.0F1B1Ac0E96A40D1": "Blockchain",
	"home.home.8Eaefb1107A0E210": "Forex",
	"home.home.Ad65263D034Ea051": "PMs",
	"home.home.5Fc1474Dbf74Ac1A": "Produse agricole",
	"home.home.135318F4664F7773": "Energie",
	"kline.kLine.C96Ff250Cf6B8B84": "Preț maxim 24h",
	"kline.kLine.6E8Be64F19D74565": "Volum tranzacționat 24h",
	"kline.kLine.08A4Bfbe26A0F262": "Preț minim 24h",
	"kline.kLine.8701Deb075066331": "Valoare tranzacționată 24h (USDT)",
	"kline.kLine.Ea3C3052136C84Cd": "1 min",
	"kline.kLine.B49Cca240E013124": "5 min",
	"kline.kLine.F27A90Be97Ba3D6C": "15 min",
	"kline.kLine.Ff3E62395B694384": "30 min",
	"kline.kLine.C1993F9C6Db1A674": "1 oră",
	"kline.kLine.Fd2Cbbae405E284C": "1 zi",
	"kline.kLine.C9Cd71904395042C": "1 lună",
	"kline.kLine.7D8127Ec18C7B8C7": "Cerere de cumpărare",
	"kline.kLine.E3D3Ffdb9B3E5636": "Cantitate (loturi)",
	"kline.kLine.6834Fec1838D8029": "Preț (USDT)",
	"kline.kLine.16C52Aae474Bc9Cd": "Cerere de vânzare",
	"kline.kLine.B9Bea1A9A88D1419": "LONG",
	"kline.kLine.D36Cfa96Ee2B343B": "SHORT",
	"other.navigationBar.F6E62F9642018Cbb": "Acasă",
	"other.navigationBar.0Ec227161A47B49D": "Piețe",
	"other.navigationBar.29761532Fc8Ebecc": "Tranzacționare",
	"other.navigationBar.693C7B35Bdf3E3A3": "Finanțe",
	"other.navigationBar.9734C54620Eb09Af": "Active",
	"home.index.25Aa4Fc745150030": "Regele criptomonedelor",
	"home.index.2D6Ecf8Faaa8B124": "Mai rapid, mai bun, mai puternic",
	"home.index.1Db26267D1041223": "Tranzacționează ușor peste 1700 criptomonede",
	"home.index.F8E18C90C3E35618": "Înregistrează-te acum",
	"home.index.29761532Fc8Ebecc": "Tranzacționare",
	"home.index.D8A95E4506487452": "Contracte populare",
	"home.index.5Bd31Fab681C6E9D": "Vezi mai mult",
	"home.index.010Ae07A09Caf221": "Perechi de tranzacționare",
	"home.index.F4D875118E6D6Dbb": "Ultimul preț tranzacționat",
	"home.index.3Dfdfb3D6599100E": "Schimbare 24h",
	"home.index.28Fb39Bd41E54242": "Grafic de preț",
	"home.index.B47A3911Bacd94C6": "Top creșteri",
	"home.index.712910D574F43D95": "Profit stabil",
	"home.index.5507Fd830D7Bf51F": "Strategii de top, replicare ușoară",
	"home.index.7De3D636A165E008": "Randament",
	"home.index.B853F96626106912": "Mergi la mining",
	"home.index.213B5C96Be7Cd1F8": "zile, randament anual",
	"home.index.213B5C96Be7Cd1F9": "Maxim cumpărabil",
	"home.index.Dc710Cffe6313Bb5": "Vezi detalii",
	"home.index.B92Ffc837Ecaa1Dd": "Știri și informații",
	"home.index.6C18D67F6D19586B": "Prezentarea platformei",
	"home.index.6342E3C33Cb48Cd5": "Criptomoneda este un mijloc de tranzacție care utilizează principiile criptografiei pentru a asigura securitatea tranzacțiilor. Spre deosebire de monedele fiat precum dolarul, criptomonedele nu au o formă fizică. Criptomonede populare precum Bitcoin (BTC), Ethereum (ETH) și Polkadot (DOT) folosesc blockchain ca tehnologie de bază, acționând ca un registru digital descentralizat. Toate tranzacțiile criptomonede sunt înregistrate pe blockchain și, odată confirmate și validate, nu pot fi modificate. Spre deosebire de monedele tradiționale, care sunt susținute de registre centralizate gestionate de bănci, tranzacțiile criptomonede au loc pe blockchain-uri publice accesibile oricui.",
	"home.index.198Efc4254683Eef": "În plus, în baza mecanismelor de consens, oricine poate verifica tranzacțiile și le poate adăuga în blockchain, realizând astfel descentralizarea. Pe măsură ce companii globale de top precum Samsung, BlackRock, Morgan Stanley și Alphabet investesc în acest domeniu, se crede că tehnologia blockchain va transforma fundamental sistemul financiar global. Criptomonedele vă deschid ușa către lumea finanțelor descentralizate, oferindu-vă posibilitatea de a explora potențialul tehnologiilor de vârf.",
	"home.index.E710339D9576292E": "Avantajele noastre",
	"home.index.F9Ce8B2C63885B26": "Siguranță și stabilitate",
	"home.index.C4D0A2C9Ff0305Ce": "Echipă tehnică de top, protecție completă, motor propriu de tranzacționare de mare viteză, funcționare stabilă chiar și la volume mari de tranzacții simultane.",
	"home.index.2E8708Ee3F11Cc1A": "Profesional și de încredere",
	"home.index.Bb12Cbcf89C56C5C": "Echipă operațională profesionistă, experiență vastă în blockchain și finanțe, licență de operare conformă, garantăm acoperire 100% pentru fonduri.",
	"home.index.Aa4723Bfbf6808F4": "Serviciu dedicat",
	"home.index.1Bf0204B7D3Ee230": "Orientat spre piața globală, suport multilingv, funcționare 24/7, comunitate puternică și servicii profesionale pentru clienți.",
	"home.index.2E7Dfd53D26F7224": "Performanță ridicată",
	"home.index.1C65453103B5Fcc3": "300.000 tranzacții pe secundă, răspuns la comenzi în mai puțin de 1 milisecundă.",
	"home.index.85Ac49Ece9Dcc80B": "Tranzacționează oriunde, oricând!",
	"home.index.2799E18842E4Ebe9": "Deschidere instantanee a pozițiilor, suport dublu pentru aplicația OKEX și web!",
	"home.index.2Bf52Ce75E29Fc88": "Scanează codul pentru descărcare imediată",
	"home.index.88D1422B33571066": "Android",
	"home.index.04Ee893775563F21": "iOS",
	"home.index.04Ee893775563F22": "Produse și servicii",
	"home.index.04Ee893775563F23": "Gestionare financiară",
	"home.index.04Ee893775563F24": "Înapoi",
	"home.index.04Ee893775563F25": "Așteptare extragere",
	"home.index.04Ee893775563F26": "iOS & Android",
	"homepage.text1": "Scopul este de a deveni prima opțiune pentru clienți",
	"homepage.text1_2": "în tranzacționarea contractelor futures pe mărfuri",
	"homepage.text2": "Experiența ta în criptomonede începe aici",
	"homepage.text4": "Gestionare financiară cu randament ridicat",
	"homepage.text5": "Gestionare financiară stabilă cu profit anual ridicat",
	"homepage.text6": "Recompense de partajare",
	"homepage.text7": "Tranzacționare rapidă, operare simplă",
	"homepage.text8": "Vezi mai mult",
	"homepage.text9": "Schimb instant",
	"homepage.text10": "Autentificare sigură, cumpărați cu încredere",
	"homepage.text11": "Echipă tehnică de top, protecție completă",
	"homepage.text12": "independentă",
	"homepage.text13": "Profesional și de încredere",
	"homepage.text14": "Echipă operațională profesionistă cu experiență vastă în blockchain și finanțe",
	"homepage.text15": "Serviciu dedicat",
	"homepage.text16": "Orientat spre piața globală, suport multilingv, funcționare nonstop",
	"homepage.text17": "Performanță ridicată",
	"homepage.text18": "Procesează 300.000 tranzacții pe secundă, răspuns la comenzi sub 1 ms",
	"passwod.limit": "Parola trebuie să aibă cel puțin 6 caractere"
}
